// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-20T23:24:14.117Z
// Property: Rolling Hills Apartments (ID: 6767906449166880)
// Collections: 17 amenities, 9 floorplans (live), 29 photos, 83 POIs, 1 reviews, 2 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166880",
  "property_external_id": "495828",
  "property_zillow_url": "https://www.zillow.com/homedetails/19355-SW-65th-Ave-APT-2-Tualatin-OR-97062/2129648067_zpid/",
  "property_apartments_url": "https://www.apartments.com/rolling-hills-apartments-tualatin-or/w7k248j/",
  "property_google_business_url": "https://www.google.com/maps/place/Rolling+Hills+Apartments/data=!4m2!3m1!1s0x0:0x82b06ca71bcc8567?sa=X&ved=2ahUKEwjd6brMgLySAxXBD1kFHSjYBqQQ_BJ6BAgREAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "52024037497",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495828 p0505496",
  "property_status": null,
  "property_slug": "rolling-hills-apartments",
  "property_name": "Rolling Hills Apartments",
  "property_website_url": "www.tualatin-apartments.com",
  "property_domain": "https://www.tualatin-apartments.com/",
  "property_address": "19355 SW 65th Ave.",
  "property_full_address": "19355 SW 65th Ave., Tualatin, OR, 97062",
  "property_address_1": "19355 Southwest 65th Avenue",
  "property_address_2": null,
  "property_address_city": "Tualatin",
  "property_address_state": "OR",
  "property_address_zip_full": null,
  "property_address_zip": "97062",
  "property_address_country": "US",
  "property_address_county": "Washington County",
  "property_neighborhood_address": "Sherwood - Tualatin South",
  "property_address_latitude": "45.3795389",
  "property_address_longitude": "-122.7453373",
  "property_email": "rollinghills@ctlmanagement.com",
  "property_phone": "(503) 564-1915",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Nestled in the heart of Tualatin, Rolling Hills offers an inviting blend of comfort and convenience. Choose from thoughtfully designed studio to three-bedroom floor plans, and enjoy amenities like a cozy coffee bar, scenic views, and ample storage. Make Rolling Hills your new home—browse our availability or schedule a tour today!",
  "property_long_description": "**Welcome to Rolling Hills Apartments in Tualatin, OR**—where comfort meets convenience in a stunning natural setting. Our diverse selection of floor plans caters to every lifestyle, featuring stylish studio, one-bedroom, two-bedroom, and three-bedroom options that are thoughtfully designed to maximize space and functionality. You’ll find modern finishes and ample closet storage that make coming home a pleasure.\n\nAt Rolling Hills, we believe in creating a vibrant community atmosphere that enriches your living experience. Enjoy your morning coffee at our inviting coffee bar, or take advantage of our self-service package lockers for hassle-free deliveries. With smoke-free housing, online rent payments, and online service requests, we've made apartment living as easy and enjoyable as possible. \n\nJoin our Resident Activity Program to engage with your neighbors and participate in community events, or catch your breath with scenic views from your apartment. Many of our residences come equipped with in-unit stackable washers and dryers, combining luxury with practicality.\n\nLocated in the heart of Tualatin, our apartment community gives you easy access to local dining, shopping, and outdoor recreation, ensuring that your lifestyle is both vibrant and fulfilling. \n\nFind your new home today at Rolling Hills! Browse our availability or schedule a tour to experience the warmth and charm of our community firsthand. Your perfect apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019db18d-a089-77d8-9151-f5672b9f5483.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior of a multifamily apartment building with gray siding and white accents.",
    "public_id": "019db18d-a089-77d8-9151-f5672b9f5483",
    "storage_key": "property/6767906449166880/019db18d-a089-77d8-9151-f5672b9f5483.webp",
    "width": 1920,
    "height": 896
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "277",
  "property_year_built": "1980",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.22382671480143",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Deposit: $400",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "400",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Deposit and monthly pet rent are per pet.  Small caged animals are allowed without a deposit and pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Max 2 Allowed | Max weight 25 lb each\nRent $25 | Deposit $400",
  "property_online_leasing_url": "https://tualatin-apartments.securecafe.com/onlineleasing/rolling-hills-2/floorplans.aspx",
  "property_resident_portal_url": "https://tualatin-apartments.securecafe.com/residentservices/rolling-hills-2/userlogin.aspx",
  "property_apply_now_url": "https://tualatin-apartments.securecafe.com/onlineleasing/rolling-hills-2/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019db1a2-ce7c-77c9-912f-c50e9cdb298e.webp",
  "property_primary_logo_media": {
    "alt_text": "Rolling Hills Apartments logo",
    "public_id": "019db1a2-ce7c-77c9-912f-c50e9cdb298e",
    "storage_key": "property/6767906449166880/019db1a2-ce7c-77c9-912f-c50e9cdb298e.webp",
    "width": 534,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019db1a2-f7b3-73f9-9307-4ec1d83b7ff2.webp",
  "property_secondary_logo_media": {
    "alt_text": "Rolling Hills Apartments logo.",
    "public_id": "019db1a2-f7b3-73f9-9307-4ec1d83b7ff2",
    "storage_key": "property/6767906449166880/019db1a2-f7b3-73f9-9307-4ec1d83b7ff2.webp",
    "width": 535,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019db1a4-ffc6-776e-9e98-80f487edc425.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Rolling Hills Apartments logo.",
    "public_id": "019db1a4-ffc6-776e-9e98-80f487edc425",
    "storage_key": "property/6767906449166880/019db1a4-ffc6-776e-9e98-80f487edc425.webp",
    "width": 534,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019db1a4-f470-7401-ad24-6f3e4ee1f049.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Rolling Hills Apartments logo",
    "public_id": "019db1a4-f470-7401-ad24-6f3e4ee1f049",
    "storage_key": "property/6767906449166880/019db1a4-f470-7401-ad24-6f3e4ee1f049.webp",
    "width": 534,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "studio - 3",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "378 - 1089",
  "property_sqft_min": "378",
  "property_sqft_max": "1089",
  "property_price_range": "1195 - 2425",
  "property_price_min": "1195",
  "property_price_max": "2425",
  "property_available_units": 15,
  "property_facebook_url": "https://www.facebook.com/rollinghillsapartmenthomes",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJy0-JcIpylVQRZ4XMG6dssII",
  "property_youtube_url": null,
  "property_yelp_url": "https://m.yelp.com/search?find_desc=Safe+Apartments&find_loc=Tualatin%2C+OR",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Rolling Hills",
  "property_home_romance_title": "Embrace the Joy of Living in Your New Community",
  "property_home_amenities_blurb": "Welcome to Rolling Hills in Tualatin, OR, where every detail enhances your lifestyle. Choose from studio to three-bedroom layouts, each designed for modern living. Enjoy a vibrant community with a coffee bar, scenic views, and convenient online services. Embrace comfort and style in your new home!",
  "property_home_floorplans_blurb": "Welcome to Rolling Hills in Tualatin, OR, where comfort meets style. Choose from a variety of thoughtfully designed floor plans, including cozy studios and spacious three-bedroom options. Each residence offers the perfect backdrop for your life. Browse our available apartment homes today and find the ideal space that reflects your unique lifestyle!",
  "property_home_gallery_blurb": "Nestled in scenic Tualatin, Rolling Hills offers an array of thoughtfully designed floor plans—studio to three-bedroom—each tailored for modern living. Enjoy a vibrant lifestyle with amenities like a cozy coffee bar and self-service package lockers. Picture yourself living here amidst comfort and convenience!",
  "property_home_neighborhood_blurb": "Experience the vibrant lifestyle at Rolling Hills in Tualatin, OR, where diverse floor plans—studios to three bedrooms—meet a rich tapestry of local culture. Enjoy nearby attractions like the Tualatin River Greenway Trail, Tualatin Community Park, and Regal Bridgeport Village, perfect for outdoor lovers and entertainment seekers alike.",
  "property_home_reviews_blurb": "Welcome to Rolling Hills in Tualatin, OR, where tranquility meets community. Residents cherish the serene environment, often saying, \"I have not felt this at home in a very long time.\" With beautiful tree coverage, refreshing breezes, and a pristine pool, your dream apartment lifestyle awaits. Join us and feel the difference!",
  "property_neighborhood_blurb": "Nestled in Tualatin, Rolling Hills offers more than just a home—it places you in a vibrant community. With nearby gems like Tualatin River Greenway Trail, Legacy Meridian Park Medical Center, and Tualatin Community Park, a world of adventure and convenience awaits. Experience a life filled with endless possibilities!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Rolling Hills in Tualatin, OR, life is infused with comfort and convenience. Sip your morning brew at our coffee bar, savor scenic views from select apartments, and enjoy hassle-free online services. With floor plans ranging from studios to three-bedrooms, your ideal home awaits—come see what sets us apart!",
  "property_applynow_blurb": "At Rolling Hills in Tualatin, OR, choose from cozy studios to spacious three-bedroom apartments, all designed for modern living. Enjoy amenities like a coffee bar, smoke-free housing, and a vibrant resident activity program. With online rent payments and scenic views, your perfect home awaits – lease online today!",
  "property_contactus_blurb": "At Rolling Hills in Tualatin, OR, your perfect home awaits with a variety of thoughtfully designed floor plans—from cozy studios to spacious three-bedroom apartments. Each layout harmonizes comfort and style, ensuring a living experience as dynamic as you are. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Rolling Hills in Tualatin, OR, we cater to every lifestyle with a variety of floor plans, including cozy studios and spacious three-bedroom apartments. Have questions about our community? Dive into our FAQs page for insights and clarity tailored just for you! Your perfect home awaits.",
  "property_floorplans_blurb": "At Rolling Hills in Tualatin, OR, your ideal living space awaits! Choose from stylish studio apartments to spacious three-bedroom homes, each thoughtfully designed for comfort and functionality. Browse our available floor plans today and envision your new lifestyle surrounded by serene landscapes and vibrant community vibes. Your next home is just a click away!",
  "property_gallery_blurb": "At Rolling Hills in Tualatin, OR, your ideal home awaits! With stylish studio to three-bedroom floor plans, unwind at our cozy coffee bar or enjoy convenient online services. Experience scenic views and spacious closets in smoke-free comfort. Picture yourself living here and embracing a vibrant community lifestyle!",
  "property_interactivemap_blurb": "At Rolling Hills in Tualatin, OR, your ideal living space awaits! Choose from stylish studio to spacious three-bedroom floor plans, complete with modern amenities like a cozy coffee bar and scenic views. Utilize our interactive community map to find your perfect apartment today—your new adventure begins here!",
  "property_pets_blurb": "Nestled in the serene landscape of Tualatin, Rolling Hills offers a vibrant community where both you and your furry companions can thrive. With a warm embrace for cats and small dogs, plus room for delightful small pets, your home here feels just right. Join us for a life of comfort and community!",
  "property_referafriend_blurb": "At Rolling Hills in Tualatin, OR, our diverse floor plans—from cozy studios to spacious three-bedroom apartments—ensure the perfect fit for everyone. Great friends make great neighbors, so share the joy of community living. Refer a friend today and embrace the lifestyle you both deserve!",
  "property_residentaccess_blurb": "At Rolling Hills in Tualatin, OR, your ideal living space awaits. Choose from thoughtfully designed studio, one, two, or three-bedroom floor plans that align perfectly with your lifestyle. Access your resident portal to effortlessly pay rent, schedule maintenance, and enjoy a seamless living experience today!",
  "property_reviews_blurb": "At Rolling Hills in Tualatin, OR, residents bask in a tranquil retreat where community and comfort converge. One resident notes, \"I have not felt this at home in a very long time,\" relishing the serene surroundings and warm sense of security. Embrace the peaceful lifestyle and see what our residents have to say!",
  "property_created_at": "1762784607223",
  "property_scheduletour_blurb": "Experience the charm of Rolling Hills in Tualatin, OR, where your ideal home awaits among our diverse floor plans—be it a cozy studio or a spacious three-bedroom. Schedule a tour today and hear firsthand how our vibrant community enhances your everyday life! Join us and find out what makes us special.",
  "property_thankyou_blurb": "Thank you for your submission! At Rolling Hills in Tualatin, OR, we offer a variety of floor plans—from cozy studios to spacious three-bedroom apartments. Our community is designed for comfort and convenience, ensuring you find the perfect space to call home. Expect to hear from our team soon!",
  "property_virtualtours_blurb": "Welcome to Rolling Hills in Tualatin, OR, where comfort meets stunning views. Whether you’re in search of a cozy studio or a spacious three-bedroom, our thoughtfully designed floor plans cater to every lifestyle. Embark on a virtual tour today and envision your future home amidst serene landscapes!",
  "property_copyright": "2025 All Rights Reserved. Rolling Hills",
  "property_seo_title_home": "Rolling Hills |  Apartments in Tualatin, OR",
  "property_seo_description_home": "Discover Rolling Hills in Tualatin, OR—modern amenities, scenic views, and flexible floor plans await your new home. Start your journey today!",
  "property_seo_title_floorplans": "Floor Plans | Tualatin, OR Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal floor plan at Rolling Hills Tualatin! Choose from cozy studios to spacious three-bedroom homes—your perfect apartment awaits. Browse now!",
  "property_seo_title_amenities": "Amenities | Tualatin, OR Apartments for Rent",
  "property_seo_description_amenities": "Discover Rolling Hills in Tualatin, OR! Enjoy premium amenities, scenic views, and hassle-free online services. Your new home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Tualatin, OR",
  "property_seo_description_gallery": "Picture yourself at Rolling Hills in Tualatin, OR! Enjoy spacious apartments, a coffee bar, scenic views, and vibrant community events. Your home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Rolling Hills Apartments",
  "property_seo_description_virtualtours": "Experience Rolling Hills in Tualatin, OR! Take a virtual tour of our studio, one, two, and three-bedroom apartments that blend luxury with comfort.",
  "property_seo_title_interactivemap": "Interactive Map | Rolling Hills Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Rolling Hills in Tualatin, OR! Use our interactive map to explore spacious floor plans, scenic views, and fantastic amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tualatin, OR",
  "property_seo_description_neighborhood": "Discover Tualatin's hidden gems near Rolling Hills! Explore vibrant shops, scenic parks, and immerse yourself in local culture today.",
  "property_seo_title_contact": "Contact Us | Rolling Hills",
  "property_seo_description_contact": "Experience the charm of Rolling Hills in Tualatin, OR. From cozy studios to spacious three-bedroom layouts, our team is ready to assist. Connect with us today!",
  "property_seo_title_faqs": "FAQs | Apartments in Tualatin, OR",
  "property_seo_description_faqs": "Find the answers you need at Rolling Hills in Tualatin, OR! Explore our FAQs to uncover all the details about our unique floor plans and amenities.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tualatin, OR",
  "property_seo_description_reviews": "Experience life at Rolling Hills in Tualatin, OR! Read resident reviews and discover amenities like a coffee bar, scenic views, and convenient online services.",
  "property_seo_title_applynow": "Apply Now | Apartments in Tualatin, OR",
  "property_seo_description_applynow": "Experience the charm of Rolling Hills in Tualatin, OR. Choose from spacious studios to three-bedroom homes with modern amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Rolling Hills",
  "property_seo_description_residentaccess": "Unlock your lifestyle at Rolling Hills, Tualatin, OR! Log in to the resident portal for easy rent payments, maintenance requests, and updates!",
  "property_seo_title_referafriend": "Refer A Friend | Rolling Hills",
  "property_seo_description_referafriend": "Refer a friend to Rolling Hills in Tualatin, OR! Enjoy great amenities and a welcoming community—where fantastic friends become great neighbors.",
  "property_seo_title_scheduletour": "Schedule a Tour | Rolling Hills",
  "property_seo_description_scheduletour": "Experience the charm of Rolling Hills in Tualatin, OR. Schedule a tour today and envision your new life in our inviting apartment community!",
  "property_seo_title_privacy": "Privacy Policy | Rolling Hills",
  "property_seo_description_privacy": "Your privacy matters at Rolling Hills in Tualatin, OR. Learn how we protect your information and maintain a secure community. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Rolling Hills",
  "property_seo_description_accessibility": "At Rolling Hills in Tualatin, OR, we prioritize digital accessibility, ensuring all guests feel welcome. Join us in creating an inclusive community today!",
  "property_seo_title_sitemap": "Sitemap | Rolling Hills",
  "property_seo_description_sitemap": "Navigate the charm of Rolling Hills in Tualatin, OR. Access our sitemap and unveil the best parts of your future home in this serene apartment community.",
  "property_seo_title_thankyou": "Thank You | Rolling Hills",
  "property_seo_description_thankyou": "Thanks for your interest in Rolling Hills! A team member will reach out soon to assist you in finding your perfect home in Tualatin, OR. Welcome!",
  "property_seo_title_pets": "Pet Policy | Apartments in Tualatin, OR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293651283",
  "amenities": [
    {
      "id": "ec_84900bf7fa57bcaa8e3d1842",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "yardi",
      "external_id": "80429357",
      "title": "Seasonal Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-5ef9-70fd-adeb-c1fbd2bc1528.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d08aa-5ef9-70fd-adeb-c1fbd2bc1528",
        "storage_key": "property/6767906449166880/019d08aa-5ef9-70fd-adeb-c1fbd2bc1528.webp",
        "width": 1024,
        "height": 732
      },
      "amenity_image_alt_text": "Pool & Sundeck at Rolling Hills Apartments, Tualatin, OR,Pool & Sundeck at Rolling Hills Apartments, OR 97062",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f8c5192dcf9e0c342ba35ae9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "yardi",
      "external_id": "80429353",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-7225-714d-ba96-217222cd0820.webp",
      "amenity_image_media": {
        "alt_text": "Playground with slides and climbing structures surrounded by autumn foliage.",
        "public_id": "019d08aa-7225-714d-ba96-217222cd0820",
        "storage_key": "property/6767906449166880/019d08aa-7225-714d-ba96-217222cd0820.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Playground at Rolling Hills Apartments, Tualatin",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_36f540677f67a56270a30d14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "yardi",
      "external_id": "80429349",
      "title": "Laundry Care Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fe36375aa9a30cb314ddb246",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "yardi",
      "external_id": "80683673",
      "title": "Garages Available to Rent",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-57e1-702f-9492-efaae0448c55.webp",
      "amenity_image_media": {
        "alt_text": "Row of single-car garages with white doors, some numbered, set against a backdrop of trees in autumn colors.",
        "public_id": "019d08aa-57e1-702f-9492-efaae0448c55",
        "storage_key": "property/6767906449166880/019d08aa-57e1-702f-9492-efaae0448c55.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Garages at Rolling Hills Apartments, Tualatin",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0869bad82da2803ce6502dbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "yardi",
      "external_id": "80429352",
      "title": "On Bus Line",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_db6707d4875561793c415f18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "yardi",
      "external_id": "80429363",
      "title": "Reserved Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bce177d9fc93019b953fd7ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "yardi",
      "external_id": "86462651",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de2d53d38bceba0c0f008158",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "yardi",
      "external_id": "86462654",
      "title": "Self-Service Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-7399-726a-8687-4acf1fc884ac.webp",
      "amenity_image_media": {
        "alt_text": "Rolling Hills apartment community package lockers",
        "public_id": "019d08aa-7399-726a-8687-4acf1fc884ac",
        "storage_key": "property/6767906449166880/019d08aa-7399-726a-8687-4acf1fc884ac.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Self service package lockers at Rolling Hills Apartments, Tualatin",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_185aff5c3683a5f42909dd73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "yardi",
      "external_id": "80429351",
      "title": "Resident Activity Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_447a6d64fbb500d091b864f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "yardi",
      "external_id": "82390247",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_22738ebc35ed6b07dc9f4cb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "yardi",
      "external_id": "82390249",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6ca2ba41f9d3aeb28ca8be44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "yardi",
      "external_id": "86462656",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_96cf735435d88524a15080fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "yardi",
      "external_id": "80429362",
      "title": "Patio or Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-3947-7238-a4c4-e4751fb845ee.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and a grassy lawn.",
        "public_id": "019d08aa-3947-7238-a4c4-e4751fb845ee",
        "storage_key": "property/6767906449166880/019d08aa-3947-7238-a4c4-e4751fb845ee.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Building exterior and green space at Rolling Hills Apartments, Tualatin",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d3688a61eab9f5bf7f96cef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "yardi",
      "external_id": "80429361",
      "title": "High Speed Internet And Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0aa16f930554978c0d8e8168",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "yardi",
      "external_id": "87310447",
      "title": "Stackable Washer & Dryer - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f65ae3ae37dc08c3eb66ebdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "yardi",
      "external_id": "87310449",
      "title": "Ample Closet Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-0729-77cd-be1c-75cda2bbeb6d.webp",
      "amenity_image_media": {
        "alt_text": "Empty bedroom with closet and doorway to hallway",
        "public_id": "019d08aa-0729-77cd-be1c-75cda2bbeb6d",
        "storage_key": "property/6767906449166880/019d08aa-0729-77cd-be1c-75cda2bbeb6d.webp",
        "width": 1024,
        "height": 732
      },
      "amenity_image_alt_text": "Apartment Master Bedroom at Rolling Hills Apartments, Tualatin, Oregon 97062",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5be5212e25590f7ff3d08c40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "yardi",
      "external_id": "87310448",
      "title": "Scenic Wetland Views - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_8f42866727a88ef1452ff226",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08a9-f85f-752f-b860-81eba27f1a43.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black appliances and white cabinets.",
        "public_id": "019d08a9-f85f-752f-b860-81eba27f1a43",
        "storage_key": "property/6767906449166880/019d08a9-f85f-752f-b860-81eba27f1a43.webp",
        "width": 848,
        "height": 1131
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring a black stove, refrigerator, and sleek white cabinetry. Perfect for preparing meals.",
      "link": "false",
      "alt_text": "Modern kitchen with black appliances and white cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Rolling Hills Upgraded Unit  (2).jpg"
    },
    {
      "id": "ec_329017968a4dc32dfa2506e9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08a9-f827-720f-9ec5-450b1e60a849.webp",
      "image_media": {
        "alt_text": "Kitchen featuring a black stove, white cabinets, and a black refrigerator.",
        "public_id": "019d08a9-f827-720f-9ec5-450b1e60a849",
        "storage_key": "property/6767906449166880/019d08a9-f827-720f-9ec5-450b1e60a849.webp",
        "width": 848,
        "height": 1131
      },
      "title": "Apartment",
      "description": "Modern kitchen with sleek black appliances, white cabinetry, and ample counter space for a comfortable and functional living experience.",
      "link": "false",
      "alt_text": "Kitchen featuring a black stove, white cabinets, and a black refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Rolling Hills Upgraded Unit  (5).jpg"
    },
    {
      "id": "ec_8bedb9eafc2d95e5d72fa14d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08a9-f8c9-7080-b4ef-0d3562783344.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets and chrome faucet.",
        "public_id": "019d08a9-f8c9-7080-b4ef-0d3562783344",
        "storage_key": "property/6767906449166880/019d08a9-f8c9-7080-b4ef-0d3562783344.webp",
        "width": 1193,
        "height": 1590
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring sleek white cabinetry, a deep sink with a stylish faucet, and ample counter space.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets and chrome faucet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Rolling Hills Upgraded Unit  (8).jpg"
    },
    {
      "id": "ec_87b55a78cf17b393bb4aed45",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08a9-f810-759f-977c-25095153b2eb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, quartz countertops, and a stainless steel sink.",
        "public_id": "019d08a9-f810-759f-977c-25095153b2eb",
        "storage_key": "property/6767906449166880/019d08a9-f810-759f-977c-25095153b2eb.webp",
        "width": 738,
        "height": 1085
      },
      "title": "Apartment",
      "description": "View of a clean and updated kitchen featuring white cabinetry, a spacious quartz countertop, and a deep stainless steel sink.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, quartz countertops, and a stainless steel sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Rolling Hills Upgraded Unit  (4).jpg"
    },
    {
      "id": "ec_f90beb471040b0d2070517ee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-04d7-773f-b4ea-c820b812031c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, black appliances, and wood floors.",
        "public_id": "019d08aa-04d7-773f-b4ea-c820b812031c",
        "storage_key": "property/6767906449166880/019d08aa-04d7-773f-b4ea-c820b812031c.webp",
        "width": 848,
        "height": 1131
      },
      "title": "Apartment",
      "description": "Bright and spacious kitchen featuring modern white cabinetry, sleek black appliances including a refrigerator and stove, and beautiful wood-look flooring. Perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, black appliances, and wood floors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Rolling Hills Upgraded Unit  (3).jpg"
    },
    {
      "id": "ec_2d984a0d5340d790265e4e16",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-061a-7629-a7ac-bc243250e002.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, wooden cabinets, and tiled flooring.",
        "public_id": "019d08aa-061a-7629-a7ac-bc243250e002",
        "storage_key": "property/6767906449166880/019d08aa-061a-7629-a7ac-bc243250e002.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "A glimpse into the apartment's kitchen, featuring white appliances, ample storage with wooden cabinets, and durable tiled flooring.",
      "link": "false",
      "alt_text": "Kitchen with white appliances, wooden cabinets, and tiled flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RollingHills_Tualatin_OR_VacantKitchen.jpg"
    },
    {
      "id": "ec_1b71f33c071e5e8e567469bb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-0656-75c8-b665-efed26574ac5.webp",
      "image_media": {
        "alt_text": "Living room with sliding glass doors to a balcony.",
        "public_id": "019d08aa-0656-75c8-b665-efed26574ac5",
        "storage_key": "property/6767906449166880/019d08aa-0656-75c8-b665-efed26574ac5.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Spacious living area with plush carpeting and access to an outdoor balcony.",
      "link": "false",
      "alt_text": "Living room with sliding glass doors to a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RollingHills_Tualatin_OR_VacantLivingRoom.jpg"
    },
    {
      "id": "ec_c5ed97a0e08066cf51f545ff",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-0729-77cd-be1c-75cda2bbeb6d.webp",
      "image_media": {
        "alt_text": "Empty bedroom with closet and doorway to hallway",
        "public_id": "019d08aa-0729-77cd-be1c-75cda2bbeb6d",
        "storage_key": "property/6767906449166880/019d08aa-0729-77cd-be1c-75cda2bbeb6d.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Spacious bedroom with ample closet space and access to a hallway.",
      "link": "false",
      "alt_text": "Empty bedroom with closet and doorway to hallway",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RollingHills_Tualatin_OR_VacantMasterBedroom.jpg"
    },
    {
      "id": "ec_2513a39acc64c01e0384ae84",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-130c-704b-83e7-e217d3d5c3d1.webp",
      "image_media": {
        "alt_text": "Kitchenette and living area in an apartment unit.",
        "public_id": "019d08aa-130c-704b-83e7-e217d3d5c3d1",
        "storage_key": "property/6767906449166880/019d08aa-130c-704b-83e7-e217d3d5c3d1.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "A compact kitchenette with wooden cabinets and a white stove, adjacent to a living area with beige carpeting.",
      "link": "false",
      "alt_text": "Kitchenette and living area in an apartment unit.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RollingHills_Tualatin_OR_VacantStudioKitchen.jpg"
    },
    {
      "id": "ec_7c201903eb15fce9b4fd655b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-1635-732c-8720-bb0ea10d2cbe.webp",
      "image_media": {
        "alt_text": "Interior of a carpeted living room with sliding glass doors leading to a balcony.",
        "public_id": "019d08aa-1635-732c-8720-bb0ea10d2cbe",
        "storage_key": "property/6767906449166880/019d08aa-1635-732c-8720-bb0ea10d2cbe.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Spacious living area with plush carpeting and a sliding glass door that opens to a private balcony, perfect for enjoying the outdoors.",
      "link": "false",
      "alt_text": "Interior of a carpeted living room with sliding glass doors leading to a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RollingHills_Tualatin_OR_VacantStudioLivingRoom.jpg"
    },
    {
      "id": "ec_39f5e98e5eca11278ccd3876",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-14bf-70bb-b57f-69d6c2348aa3.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, bathtub, and vanity with sink.",
        "public_id": "019d08aa-14bf-70bb-b57f-69d6c2348aa3",
        "storage_key": "property/6767906449166880/019d08aa-14bf-70bb-b57f-69d6c2348aa3.webp",
        "width": 732,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a toilet, a bathtub with a shower, and a vanity with a sink and mirror.",
      "link": "false",
      "alt_text": "Bathroom with toilet, bathtub, and vanity with sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RollingHills_Tualatin_OR_VacantBathroom.jpg"
    },
    {
      "id": "ec_a1782b8964dea401c5ad6e2d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-1d7a-7418-938c-52bfa5b1260c.webp",
      "image_media": {
        "alt_text": "Rolling Hills Apartments monument sign",
        "public_id": "019d08aa-1d7a-7418-938c-52bfa5b1260c",
        "storage_key": "property/6767906449166880/019d08aa-1d7a-7418-938c-52bfa5b1260c.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Welcome to Rolling Hills Apartments, located at 19355. This monument sign marks the entrance to our community.",
      "link": "false",
      "alt_text": "Rolling Hills Apartments monument sign",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RollingHills_Tualatin_OR_MonumentSign(1).jpg"
    },
    {
      "id": "ec_5acc335a860dc460b83b3881",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-252d-770b-8358-f45556c2d047.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with parking lot and landscaping.",
        "public_id": "019d08aa-252d-770b-8358-f45556c2d047",
        "storage_key": "property/6767906449166880/019d08aa-252d-770b-8358-f45556c2d047.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings, showcasing the architecture, landscaping, and parking area.",
      "link": "false",
      "alt_text": "Exterior of apartment buildings with parking lot and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RollingHills_Tualatin_OR_Building1ExteriorEntries.jpg"
    },
    {
      "id": "ec_d76149c3bcbde539990dfcc7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-2a13-7010-b10b-c04aee7b2baf.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with parking lot in the foreground.",
        "public_id": "019d08aa-2a13-7010-b10b-c04aee7b2baf",
        "storage_key": "property/6767906449166880/019d08aa-2a13-7010-b10b-c04aee7b2baf.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Modern apartment buildings with a clean parking lot and lush landscaping. Offering a comfortable living experience.",
      "link": "false",
      "alt_text": "Exterior of apartment buildings with parking lot in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RollingHills_Tualatin_OR_Building2ExteriorEntries.jpg"
    },
    {
      "id": "ec_9f5795e96b0ed9a6d72a8b1b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-26fc-74b5-9e76-9213450f0805.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with a parking lot in the foreground.",
        "public_id": "019d08aa-26fc-74b5-9e76-9213450f0805",
        "storage_key": "property/6767906449166880/019d08aa-26fc-74b5-9e76-9213450f0805.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Discover comfortable living at this apartment complex, featuring well-maintained exteriors and ample parking.",
      "link": "false",
      "alt_text": "Exterior of apartment buildings with a parking lot in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RollingHills_Tualatin_OR_Building2ExteriorEntriesParkingLot.jpg"
    },
    {
      "id": "ec_e9e3d544a0be4812020c10b2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-373a-7069-a996-f01b0ef01f8d.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a parking lot in the foreground.",
        "public_id": "019d08aa-373a-7069-a996-f01b0ef01f8d",
        "storage_key": "property/6767906449166880/019d08aa-373a-7069-a996-f01b0ef01f8d.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "A view of the apartment buildings and the surrounding landscaping, showcasing the community's exterior design and common areas.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with a parking lot in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RollingHills_Tualatin_OR_Building4ExteriorEntries.jpg"
    },
    {
      "id": "ec_0062facc3fe48f370d382aef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-3947-7238-a4c4-e4751fb845ee.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and a grassy lawn.",
        "public_id": "019d08aa-3947-7238-a4c4-e4751fb845ee",
        "storage_key": "property/6767906449166880/019d08aa-3947-7238-a4c4-e4751fb845ee.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "The exterior of the apartment building showcases balconies and well-maintained grounds, offering a glimpse of the property's charm and ambiance.",
      "link": "false",
      "alt_text": "Exterior view of a multi-story apartment building with balconies and a grassy lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RollingHills_Tualatin_OR_BuildingExteriorGreenSpace.jpg"
    },
    {
      "id": "ec_80870e233e80e6763a12c6e3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-454d-726c-977a-488908c0f84d.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns.",
        "public_id": "019d08aa-454d-726c-977a-488908c0f84d",
        "storage_key": "property/6767906449166880/019d08aa-454d-726c-977a-488908c0f84d.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "View of the apartment building exteriors, showcasing balconies and well-maintained green spaces. A perfect place to call home.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RollingHills_Tualatin_OR_PatiosandDecks.jpg"
    },
    {
      "id": "ec_61bc4c34632eddc1eee57eb6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-4562-70be-9a4d-5efa2a90dc9b.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and trees.",
        "public_id": "019d08aa-4562-70be-9a4d-5efa2a90dc9b",
        "storage_key": "property/6767906449166880/019d08aa-4562-70be-9a4d-5efa2a90dc9b.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Charming exterior of the apartment building showcasing spacious balconies and lush greenery, offering a serene living environment.",
      "link": "false",
      "alt_text": "Exterior view of a multi-story apartment building with balconies and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RollingHills_Tualatin_OR_PatiosandDecksCommonArea.jpg"
    },
    {
      "id": "ec_ae139282b8cef0ec86909573",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-4ee0-779b-bbe6-5e1aad51dc07.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with colorful autumn trees.",
        "public_id": "019d08aa-4ee0-779b-bbe6-5e1aad51dc07",
        "storage_key": "property/6767906449166880/019d08aa-4ee0-779b-bbe6-5e1aad51dc07.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Charming apartment buildings nestled amongst vibrant autumn foliage, offering a picturesque living environment.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with colorful autumn trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RollingHills_Tualatin_OR_TwoStoryBuildingCottagePatiosandDecks.jpg"
    },
    {
      "id": "ec_0f8d9aa1366ddeb77dfb0ac4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-57e1-702f-9492-efaae0448c55.webp",
      "image_media": {
        "alt_text": "Row of single-car garages with white doors, some numbered, set against a backdrop of trees in autumn colors.",
        "public_id": "019d08aa-57e1-702f-9492-efaae0448c55",
        "storage_key": "property/6767906449166880/019d08aa-57e1-702f-9492-efaae0448c55.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Secure and convenient garage parking available for residents, with ample space to store vehicles and belongings.",
      "link": "false",
      "alt_text": "Row of single-car garages with white doors, some numbered, set against a backdrop of trees in autumn colors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RollingHills_Tualatin_OR_Garages(1).jpg"
    },
    {
      "id": "ec_13eb7b88b922f6bbf0400160",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-5b39-705c-914f-e33af84f5137.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08aa-5b39-705c-914f-e33af84f5137",
        "storage_key": "property/6767906449166880/019d08aa-5b39-705c-914f-e33af84f5137.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and shaded by umbrellas. Perfect for relaxing on sunny days.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RollingHills_Tualatin_OR_Pool01.jpg"
    },
    {
      "id": "ec_9ff283d5c8061d2fb743cf37",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-5ef9-70fd-adeb-c1fbd2bc1528.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d08aa-5ef9-70fd-adeb-c1fbd2bc1528",
        "storage_key": "property/6767906449166880/019d08aa-5ef9-70fd-adeb-c1fbd2bc1528.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, perfect for relaxing on sunny days. Lounge chairs and umbrellas are available for your comfort.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RollingHills_Tualatin_OR_Pool02.jpg"
    },
    {
      "id": "ec_0158e94a0a8b1270655535f6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-7225-714d-ba96-217222cd0820.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structures surrounded by autumn foliage.",
        "public_id": "019d08aa-7225-714d-ba96-217222cd0820",
        "storage_key": "property/6767906449166880/019d08aa-7225-714d-ba96-217222cd0820.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation at our community playground, perfect for family fun amidst vibrant fall colors.",
      "link": "false",
      "alt_text": "Playground with slides and climbing structures surrounded by autumn foliage.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RollingHills_Tualatin_OR_Playground(1).jpg"
    },
    {
      "id": "ec_4fd148016bc6f41657794a4e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-7399-726a-8687-4acf1fc884ac.webp",
      "image_media": {
        "alt_text": "Rolling Hills apartment community package lockers",
        "public_id": "019d08aa-7399-726a-8687-4acf1fc884ac",
        "storage_key": "property/6767906449166880/019d08aa-7399-726a-8687-4acf1fc884ac.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Convenient package lockers for residents of Rolling Hills apartments.",
      "link": "false",
      "alt_text": "Rolling Hills apartment community package lockers",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RollingHills_Tualatin_OR_SelfServicePackageLockers.jpg"
    },
    {
      "id": "ec_3245221816decccc49c9a4b0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08aa-73c3-702a-885c-f1b54bb6a798.webp",
      "image_media": {
        "alt_text": "Mailboxes and leasing office sign at an apartment complex.",
        "public_id": "019d08aa-73c3-702a-885c-f1b54bb6a798",
        "storage_key": "property/6767906449166880/019d08aa-73c3-702a-885c-f1b54bb6a798.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Convenient mail delivery to your door with these secure mailboxes located near the leasing office at our community.",
      "link": "false",
      "alt_text": "Mailboxes and leasing office sign at an apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/RollingHills_Tualatin_OR_MailStation(1).jpg"
    },
    {
      "id": "ec_a4341ef7da95f8a13b3bfe9c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d4cc1-74e8-73fe-b387-67c48c0fe745.webp",
      "image_media": {
        "alt_text": "Parque Las Casitas monument sign with playground and recreational areas in the background.",
        "public_id": "019d4cc1-74e8-73fe-b387-67c48c0fe745",
        "storage_key": "property/6767906449166880/019d4cc1-74e8-73fe-b387-67c48c0fe745.webp",
        "width": 1987,
        "height": 2069
      },
      "title": "Community",
      "description": "Welcome to Parque Las Casitas, a vibrant community space featuring a playground, picnic areas, and recreational facilities for all to enjoy.",
      "link": "false",
      "alt_text": "Parque Las Casitas monument sign with playground and recreational areas in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/City of Tualatin - Parque Las Casitas Sign.jpg"
    },
    {
      "id": "ec_b9226ddb4dc8ae1793ae093d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d4cc1-6e90-77e6-88d1-3003a8bf7c8d.webp",
      "image_media": {
        "alt_text": "Playground with slides, swings, and benches",
        "public_id": "019d4cc1-6e90-77e6-88d1-3003a8bf7c8d",
        "storage_key": "property/6767906449166880/019d4cc1-6e90-77e6-88d1-3003a8bf7c8d.webp",
        "width": 872,
        "height": 638
      },
      "title": "Community",
      "description": "A vibrant community playground featuring modern play structures, slides, swings, and shaded seating areas for residents to enjoy outdoor recreation.",
      "link": "false",
      "alt_text": "Playground with slides, swings, and benches",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/City of Tualatin - Parque Las Casitas.png"
    },
    {
      "id": "ec_55e01d2e238226b252cd31a0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d4cc1-6e20-712e-bd24-16bbd133f17b.webp",
      "image_media": {
        "alt_text": "Outdoor recreation area with playground, basketball court, picnic tables, and benches.",
        "public_id": "019d4cc1-6e20-712e-bd24-16bbd133f17b",
        "storage_key": "property/6767906449166880/019d4cc1-6e20-712e-bd24-16bbd133f17b.webp",
        "width": 892,
        "height": 630
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation at our community's playground, basketball court, and picnic areas, perfect for family fun and relaxation.",
      "link": "false",
      "alt_text": "Outdoor recreation area with playground, basketball court, picnic tables, and benches.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/City of Tualatin -Parque Las Casitas Basketball Court.png"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_1da477f0c7c8069783218ab8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Brix Tavern - Tualatin",
      "poi_type": "Restaurants",
      "poi_address": "8187 SW Tualatin-Sherwood Rd, Tualatin, OR 97062, USA",
      "poi_short_description": "Cozy space offering classic American comfort food and an extensive selection of beers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-4952-7358-a853-ac29416cc727.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-4952-7358-a853-ac29416cc727",
        "storage_key": "property/6767906449166880/019d08ab-4952-7358-a853-ac29416cc727.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://brixtavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17735836944645877810&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brix-tavern---tualatin",
      "poi_latitude": "45.3819397",
      "poi_longitude": "-122.761212",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 503-410-7553",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-f54a-737c-a191-a66ccaaa5b12",
        "storage_key": "property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJd0V4UeVzlVQRMvDdj7tZIvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_3fab54496b1da17412bda6c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "7149 SW Nyberg St Building L, Tualatin, OR 97062, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-46ea-75b3-93d5-053aee4fd5a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-46ea-75b3-93d5-053aee4fd5a5",
        "storage_key": "property/6767906449166880/019d08ab-46ea-75b3-93d5-053aee4fd5a5.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/or/tualatin/7149-sw-nyberg-st?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=202152&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=4573517723228882045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "45.3830117",
      "poi_longitude": "-122.7489486",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 503-691-2162",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-f550-7761-bab2-dd8051e01c62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-f550-7761-bab2-dd8051e01c62",
        "storage_key": "property/6767906449166880/019d08ab-f550-7761-bab2-dd8051e01c62.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJnRK2n4tylVQRfcQCQyNmeD8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_89685fcdda7b7691897b73d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Sunny's Diner Tualatin - Nyberg Woods",
      "poi_type": "Restaurants",
      "poi_address": "7107 SW Nyberg St, Tualatin, OR 97062, USA",
      "poi_short_description": "Casual restaurant for breakfast and lunch serving up omelets, cinnamon rolls, and other comfort classics.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-46ec-749f-a266-050284e0b62d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-46ec-749f-a266-050284e0b62d",
        "storage_key": "property/6767906449166880/019d08ab-46ec-749f-a266-050284e0b62d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sunnysdiner.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12493664251613454544&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunnys-diner-tualatin---nyberg-woods",
      "poi_latitude": "45.383413",
      "poi_longitude": "-122.7505794",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 503-658-9988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-f54a-737c-a191-a66ccaaa5b12",
        "storage_key": "property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB0BIOZFzlVQR0KBqTHFpYq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_2107cedca87d906a4ae5d30d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Famous Dave's Bar-B-Que",
      "poi_type": "Restaurants",
      "poi_address": "7121 SW Nyberg St, Tualatin, OR 97062, USA",
      "poi_short_description": "Outlet of a BBQ chain serving wood-smoked meats & sides in an American West-themed space.",
      "poi_long_description": "Outlet of a BBQ chain serving wood-smoked meats & sides in an American West-themed space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-4718-710f-a403-0e489cb5bab6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-4718-710f-a403-0e489cb5bab6",
        "storage_key": "property/6767906449166880/019d08ab-4718-710f-a403-0e489cb5bab6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.famousdaves.com/Tualatin",
      "poi_directions_map_url": "https://maps.google.com/?cid=8410756611523014193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "famous-daves-bar-b-que",
      "poi_latitude": "45.383069",
      "poi_longitude": "-122.750012",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 503-486-5631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-f54a-737c-a191-a66ccaaa5b12",
        "storage_key": "property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCVM3dYtylVQRMe4YepMCuXQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_9d12315d656a3466162f9de4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Five Guys",
      "poi_type": "Restaurants",
      "poi_address": "7005 SW Nyberg St, Tualatin, OR 97062, USA",
      "poi_short_description": "Fast-food chain with made-to-order burgers, fries & hot dogs, plus free peanuts while you wait.",
      "poi_long_description": "Fast-food chain with made-to-order burgers, fries & hot dogs, plus free peanuts while you wait.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-4eb9-75cf-8c64-9e5b80e2fc58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-4eb9-75cf-8c64-9e5b80e2fc58",
        "storage_key": "property/6767906449166880/019d08ab-4eb9-75cf-8c64-9e5b80e2fc58.webp",
        "width": 1280,
        "height": 1087
      },
      "poi_business_url": "https://restaurants.fiveguys.com/7005-sw-nyberg-road",
      "poi_directions_map_url": "https://maps.google.com/?cid=963567680466186306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "five-guys",
      "poi_latitude": "45.3830072",
      "poi_longitude": "-122.74808",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 971-252-3171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-f54a-737c-a191-a66ccaaa5b12",
        "storage_key": "property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJF-CNdotylVQRQvA7P7NHXw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_22f103fbdcc919ef650ad948",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "7003 SW Nyberg St, Tualatin, OR 97062, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-4f62-707b-9afa-a087151f0e9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-4f62-707b-9afa-a087151f0e9f",
        "storage_key": "property/6767906449166880/019d08ab-4f62-707b-9afa-a087151f0e9f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.chipotle.com/or/tualatin/7003-sw-nyberg-st?utm_source=google&utm_medium=yext&utm_campaign=yext_listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=6680790943678090914&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "45.3830119",
      "poi_longitude": "-122.7482003",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 503-692-5709",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-f54a-737c-a191-a66ccaaa5b12",
        "storage_key": "property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4Z5wmYtylVQRok6UiPfvtlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_be97e9c1721299a1e9a0e191",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Shake Shack Bridgeport Village",
      "poi_type": "Restaurants",
      "poi_address": "7439 SW Bridgeport Rd, Tigard, OR 97224, USA",
      "poi_short_description": "Hip, counter-serve chain for gourmet takes on fast-food classics like burgers & frozen custard.",
      "poi_long_description": "Hip, counter-serve chain for gourmet takes on fast-food classics like burgers & frozen custard.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-4f96-756d-8317-d8e8a4cdc31b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-4f96-756d-8317-d8e8a4cdc31b",
        "storage_key": "property/6767906449166880/019d08ab-4f96-756d-8317-d8e8a4cdc31b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://shakeshack.com/location/-OR?utm_source=google&utm_medium=listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12504423123922065986&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shake-shack-bridgeport-village",
      "poi_latitude": "45.3954235",
      "poi_longitude": "-122.7524112",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 971-979-1102",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-f54a-737c-a191-a66ccaaa5b12",
        "storage_key": "property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTZzfzONzlVQRQhqOdpSiiK0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_d9a1f41d5af9e5dbca8eae66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "P.F. Chang's",
      "poi_type": "Restaurants",
      "poi_address": "7463 SW Bridgeport Rd, Tigard, OR 97224, USA",
      "poi_short_description": "Family-friendly chain offering creative takes on Asian fare in a striking space.",
      "poi_long_description": "Family-friendly chain offering creative takes on Asian fare in a striking space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-5496-7131-9f3f-32e69b0064cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-5496-7131-9f3f-32e69b0064cb",
        "storage_key": "property/6767906449166880/019d08ab-5496-7131-9f3f-32e69b0064cb.webp",
        "width": 1280,
        "height": 1257
      },
      "poi_business_url": "https://locations.pfchangs.com/or/tigard/7463-sw-bridgeport-rd.html?utm_source=google_gbp&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=9570698550243292662&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pf-changs",
      "poi_latitude": "45.3956898",
      "poi_longitude": "-122.7524279",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-430-3020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-f54a-737c-a191-a66ccaaa5b12",
        "storage_key": "property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4VfBbetylVQR9vWYq5_z0YQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_e7a62d894961a3cf30ca7d40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Pastini",
      "poi_type": "Restaurants",
      "poi_address": "7307 SW Bridgeport Rd B-105, Tigard, OR 97224, USA",
      "poi_short_description": "Local Italian bistro chain specializing in classic & contemporary pastas, with gluten-free options.",
      "poi_long_description": "Local Italian bistro chain specializing in classic & contemporary pastas, with gluten-free options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-56c7-709f-9cfd-93c04d136b0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-56c7-709f-9cfd-93c04d136b0e",
        "storage_key": "property/6767906449166880/019d08ab-56c7-709f-9cfd-93c04d136b0e.webp",
        "width": 1280,
        "height": 856
      },
      "poi_business_url": "http://www.pastini.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13893094823146607900&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pastini",
      "poi_latitude": "45.3969163",
      "poi_longitude": "-122.7512105",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-718-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-f54a-737c-a191-a66ccaaa5b12",
        "storage_key": "property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ65Ce2etylVQRHNV4BCIwzsA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_86b94161113ca70cb1dd17c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "California Pizza Kitchen at Bridgeport",
      "poi_type": "Restaurants",
      "poi_address": "Bridgeport Blg. R2 Sp, 7315 SW Bridgeport Rd, Portland, OR 97224, USA",
      "poi_short_description": "Chain eatery serving up inventive pizzas, plus pastas & salads in a modern setting.",
      "poi_long_description": "Chain eatery serving up inventive pizzas, plus pastas & salads in a modern setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-56a9-74cd-bf79-56ad38b720ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-56a9-74cd-bf79-56ad38b720ed",
        "storage_key": "property/6767906449166880/019d08ab-56a9-74cd-bf79-56ad38b720ed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://order.cpk.com/menu/california-pizza-kitchen-bridgeport/?utm_source=GMB&utm_medium=GMB",
      "poi_directions_map_url": "https://maps.google.com/?cid=3850050788374425981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "california-pizza-kitchen-at-bridgeport",
      "poi_latitude": "45.397216",
      "poi_longitude": "-122.7513245",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-968-0504",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-f54a-737c-a191-a66ccaaa5b12",
        "storage_key": "property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJia4H2-tylVQRfTFFKMsgbjU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_4e9b6d12ccc32386d6082b00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Kona Grill - Tigard",
      "poi_type": "Restaurants",
      "poi_address": "17003 SW 72nd Ave, Tigard, OR 97224, USA",
      "poi_short_description": "Sleek chain with a broad New American menu including low-calorie options, plus sushi & cocktails.",
      "poi_long_description": "Sleek chain with a broad New American menu including low-calorie options, plus sushi & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-569f-7739-87b9-ae37508455d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-569f-7739-87b9-ae37508455d1",
        "storage_key": "property/6767906449166880/019d08ab-569f-7739-87b9-ae37508455d1.webp",
        "width": 1280,
        "height": 996
      },
      "poi_business_url": "https://konagrill.com/locations?locations=Tigard",
      "poi_directions_map_url": "https://maps.google.com/?cid=14833317316099468400&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kona-grill---tigard",
      "poi_latitude": "45.397557",
      "poi_longitude": "-122.750766",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 971-329-4392",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-f54a-737c-a191-a66ccaaa5b12",
        "storage_key": "property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfWfVq0lzlVQRcGzCOoKH2s0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_478fc282c17e8c861f465ce1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Peet's Coffee",
      "poi_type": "Restaurants",
      "poi_address": "7471 SW Bridgeport Rd Bldg. G Bldg G, Tigard, OR 97224, USA",
      "poi_short_description": "Berkeley-born chain featuring signature coffee, tea & blended drinks alongside baked goods.",
      "poi_long_description": "Berkeley-born chain featuring signature coffee, tea & blended drinks alongside baked goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-5bab-716e-a8df-a5805ea7865f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-5bab-716e-a8df-a5805ea7865f",
        "storage_key": "property/6767906449166880/019d08ab-5bab-716e-a8df-a5805ea7865f.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.peets.com/pages/store-locator?stockist-query=Tigard%2C+OR%2C+USA&selected=Bridgeport+Village",
      "poi_directions_map_url": "https://maps.google.com/?cid=15381673775551314156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peets-coffee",
      "poi_latitude": "45.395272",
      "poi_longitude": "-122.752058",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-684-2726",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-f550-7761-bab2-dd8051e01c62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-f550-7761-bab2-dd8051e01c62",
        "storage_key": "property/6767906449166880/019d08ab-f550-7761-bab2-dd8051e01c62.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJwd_ObetylVQR7Hitos2udtU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_5242ec2a79d47f8754e2d194",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Roxy's Island Grill",
      "poi_type": "Restaurants",
      "poi_address": "8290 SW Nyberg St, Tualatin, OR 97062, USA",
      "poi_short_description": "Counter-service Hawaiian restaurant with floral decor serving plate lunches & burgers.",
      "poi_long_description": "Counter-service Hawaiian restaurant with floral decor serving plate lunches & burgers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-5d24-775c-a518-9fe6b073fdb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-5d24-775c-a518-9fe6b073fdb3",
        "storage_key": "property/6767906449166880/019d08ab-5d24-775c-a518-9fe6b073fdb3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.roxysislandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8177646267966303149&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roxys-island-grill",
      "poi_latitude": "45.3825024",
      "poi_longitude": "-122.7619929",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 971-444-9835",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-f54a-737c-a191-a66ccaaa5b12",
        "storage_key": "property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIeJie4VylVQRrSvuJPTVfHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_b8d4e7168078edd3b26bbe72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Stickmen Brewing Company - Tualatin",
      "poi_type": "Restaurants",
      "poi_address": "19475 SW 118th Ave #1, Tualatin, OR 97062, USA",
      "poi_short_description": "Casual brewpub featuring a range of craft beers from IPA to stouts plus artisan pizzas baked in wood-fired ovens.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-5e27-719f-9405-c2c8ffb8a1f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-5e27-719f-9405-c2c8ffb8a1f9",
        "storage_key": "property/6767906449166880/019d08ab-5e27-719f-9405-c2c8ffb8a1f9.webp",
        "width": 960,
        "height": 960
      },
      "poi_business_url": "https://stickmenbeer.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17515780218292286987&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stickmen-brewing-company---tualatin",
      "poi_latitude": "45.3794333",
      "poi_longitude": "-122.7996447",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-486-7197",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-f54a-737c-a191-a66ccaaa5b12",
        "storage_key": "property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6QvjGWltlVQRCzYgU06NFPM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_4253b737bc0347140bacdd74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Sushi and Thai",
      "poi_type": "Restaurants",
      "poi_address": "19352 SW Boones Ferry Rd, Tualatin, OR 97062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-5e82-711e-9c07-f716c221b9d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-5e82-711e-9c07-f716c221b9d3",
        "storage_key": "property/6767906449166880/019d08ab-5e82-711e-9c07-f716c221b9d3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6085350181325134060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sushi-and-thai",
      "poi_latitude": "45.37996",
      "poi_longitude": "-122.7639221",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-427-0526",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-f54a-737c-a191-a66ccaaa5b12",
        "storage_key": "property/6767906449166880/019d08ab-f54a-737c-a191-a66ccaaa5b12.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuaDBijJzlVQR7Fi-k7-Bc1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_5c0c1065f769148cea7b765f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "19200 SW Martinazzi Ave, Tualatin, OR 97062, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-622b-766a-81fc-96cce2f0d4d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-622b-766a-81fc-96cce2f0d4d2",
        "storage_key": "property/6767906449166880/019d08ab-622b-766a-81fc-96cce2f0d4d2.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/or/tualatin/tualatin/701/00393?cid=loc_70100393_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=18139098472642568822&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "45.3814933",
      "poi_longitude": "-122.7571052",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 503-691-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-f54c-7391-894b-a48e13d8334b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-f54c-7391-894b-a48e13d8334b",
        "storage_key": "property/6767906449166880/019d08ab-f54c-7391-894b-a48e13d8334b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe2ftSo9ylVQRduKwr_QFu_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_fe1a17d932cb8f58d74fc01e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Plaid Pantry",
      "poi_type": "Shopping & Retail",
      "poi_address": "19405 SW Boones Ferry Rd, Tualatin, OR 97062, USA",
      "poi_short_description": "Convenience-store chain stocking beer & wine, health beverages & packaged snacks.",
      "poi_long_description": "Convenience-store chain stocking beer & wine, health beverages & packaged snacks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-6644-70ee-96d9-a83dc2eafab2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-6644-70ee-96d9-a83dc2eafab2",
        "storage_key": "property/6767906449166880/019d08ab-6644-70ee-96d9-a83dc2eafab2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.plaidpantry.com/store/tualatin//",
      "poi_directions_map_url": "https://maps.google.com/?cid=8606347752423848942&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "plaid-pantry",
      "poi_latitude": "45.3795093",
      "poi_longitude": "-122.7650125",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-692-5819",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-f54a-737c-a191-a0964b38ae93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-f54a-737c-a191-a0964b38ae93",
        "storage_key": "property/6767906449166880/019d08ab-f54a-737c-a191-a0964b38ae93.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJP8e6EIRylVQR7nu0tK7jb3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_917632abf9e1a553cf57a0e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "7041 SW Nyberg St, Tualatin, OR 97062, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-6665-74fa-83f6-0a7e38d58af7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-6665-74fa-83f6-0a7e38d58af7",
        "storage_key": "property/6767906449166880/019d08ab-6665-74fa-83f6-0a7e38d58af7.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "https://stores.bestbuy.com/or/tualatin/7041-sw-nyberg-st-1422.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=16934713390871859612&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "45.38542899999999",
      "poi_longitude": "-122.749217",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 503-612-8397",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd3b-74af-b2fb-2e0e564abdb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd3b-74af-b2fb-2e0e564abdb3",
        "storage_key": "property/6767906449166880/019d08ab-fd3b-74af-b2fb-2e0e564abdb3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJj2Tfn4tylVQRnNH34xowBOs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "ec_5551dcfd4ee4cc3cac407d71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Ulta Beauty",
      "poi_type": "Shopping & Retail",
      "poi_address": "7081 SW Nyberg St, Tualatin, OR 97062, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-660d-7153-80a6-3c1f4ef3e131.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-660d-7153-80a6-3c1f4ef3e131",
        "storage_key": "property/6767906449166880/019d08ab-660d-7153-80a6-3c1f4ef3e131.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/tualatin-or-258",
      "poi_directions_map_url": "https://maps.google.com/?cid=13056142182721210940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "45.3842479",
      "poi_longitude": "-122.7506722",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 503-692-1501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-zeghotylVQRPEoXCiS8MLU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "ec_fa74f68dba9941647346a511",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "PetSmart",
      "poi_type": "Shopping & Retail",
      "poi_address": "7029 SW Nyberg St, Tualatin, OR 97062, USA",
      "poi_short_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_long_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-69b6-75d4-9925-15a375380bfe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-69b6-75d4-9925-15a375380bfe",
        "storage_key": "property/6767906449166880/019d08ab-69b6-75d4-9925-15a375380bfe.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.petsmart.com/stores/us/or/tualatin-store1696.html?utm_source=google&utm_medium=organic&utm_campaign=google-my-business",
      "poi_directions_map_url": "https://maps.google.com/?cid=17428016942682356357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "petsmart",
      "poi_latitude": "45.3841804",
      "poi_longitude": "-122.7485894",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 503-692-5769",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd3b-74af-b2fb-2e0e564abdb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd3b-74af-b2fb-2e0e564abdb3",
        "storage_key": "property/6767906449166880/019d08ab-fd3b-74af-b2fb-2e0e564abdb3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJN1BgdYtylVQRhToSYBLB3PE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_9d5d2f1151078d42f09c70a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Nyberg Woods",
      "poi_type": "Shopping & Retail",
      "poi_address": "7061 SW Nyberg St, Tualatin, OR 97062, USA",
      "poi_short_description": "Landscaped mall with clothing chains, plus stores selling electronics and pet supplies.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-6fe8-7567-b692-1a3e70bb2460.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-6fe8-7567-b692-1a3e70bb2460",
        "storage_key": "property/6767906449166880/019d08ab-6fe8-7567-b692-1a3e70bb2460.webp",
        "width": 1280,
        "height": 893
      },
      "poi_business_url": "https://www.shopnybergwoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17957676255115837222&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nyberg-woods",
      "poi_latitude": "45.384337",
      "poi_longitude": "-122.749371",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 503-968-8940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd3b-74af-b2fb-2e0e564abdb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd3b-74af-b2fb-2e0e564abdb3",
        "storage_key": "property/6767906449166880/019d08ab-fd3b-74af-b2fb-2e0e564abdb3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJW3ogj4xylVQRJn-lAWl7Nvk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_4e38e28ee647b5225d52cdd0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Bridgeport Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "7455 SW Bridgeport Rd, Tigard, OR 97224, USA",
      "poi_short_description": "Outdoor shopping complex featuring entertainment, high-end retailers & sit-down & casual dining.",
      "poi_long_description": "Outdoor shopping complex featuring entertainment, high-end retailers & sit-down & casual dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-6eed-768d-bb38-82ddac2f078c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-6eed-768d-bb38-82ddac2f078c",
        "storage_key": "property/6767906449166880/019d08ab-6eed-768d-bb38-82ddac2f078c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bridgeport-village.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2515733834919836986&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bridgeport-village",
      "poi_latitude": "45.3957237",
      "poi_longitude": "-122.7528244",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-968-1704",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd3b-74af-b2fb-2e0e564abdb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd3b-74af-b2fb-2e0e564abdb3",
        "storage_key": "property/6767906449166880/019d08ab-fd3b-74af-b2fb-2e0e564abdb3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnYnrbetylVQROv3TC5iu6SI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_d659a4c6dbfa188062ed6b77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Apple Bridgeport Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "7273 SW Bridgeport Rd, Tigard, OR 97224, USA",
      "poi_short_description": "Apple retail store selling iPhones, iPads & more in sleekly designed spaces.",
      "poi_long_description": "Apple retail store selling iPhones, iPads & more in sleekly designed spaces.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-70dd-765d-aa3c-fbb79400c8e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-70dd-765d-aa3c-fbb79400c8e5",
        "storage_key": "property/6767906449166880/019d08ab-70dd-765d-aa3c-fbb79400c8e5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.apple.com/retail/bridgeportvillage?cid=aos-us-seo-maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=16799744758187856756&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "apple-bridgeport-village",
      "poi_latitude": "45.3967547",
      "poi_longitude": "-122.75114",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-670-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd3b-74af-b2fb-2e0e564abdb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd3b-74af-b2fb-2e0e564abdb3",
        "storage_key": "property/6767906449166880/019d08ab-fd3b-74af-b2fb-2e0e564abdb3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJGaHmi-lylVQRdJMERdmuJOk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "ec_7f89829b32021898d6769471",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "7380 SW Bridgeport Rd, Tigard, OR 97224, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-7336-75be-9c0c-13c41163c464.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-7336-75be-9c0c-13c41163c464",
        "storage_key": "property/6767906449166880/019d08ab-7336-75be-9c0c-13c41163c464.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/tigard?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=16814592006069935487&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "45.3944787",
      "poi_longitude": "-122.7515006",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-639-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-f54c-7391-894b-a48e13d8334b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-f54c-7391-894b-a48e13d8334b",
        "storage_key": "property/6767906449166880/019d08ab-f54c-7391-894b-a48e13d8334b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpbWCletylVQRf93rjFduWek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_0668cee68b7fab8d9ace35c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "SEPHORA",
      "poi_type": "Shopping & Retail",
      "poi_address": "7397 SW Bridgeport Rd SPC C-104, Tigard, OR 97224, USA",
      "poi_short_description": "Retail chain with a selection of upmarket makeup, perfumes, beauty & skincare products.",
      "poi_long_description": "Retail chain with a selection of upmarket makeup, perfumes, beauty & skincare products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-7951-772e-a004-7fa4f8fdd14f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-7951-772e-a004-7fa4f8fdd14f",
        "storage_key": "property/6767906449166880/019d08ab-7951-772e-a004-7fa4f8fdd14f.webp",
        "width": 500,
        "height": 277
      },
      "poi_business_url": "https://www.sephora.com/happening/stores/bridgeport-village?utm_source=gmb&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=5202209678674855551&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sephora",
      "poi_latitude": "45.3962401",
      "poi_longitude": "-122.7527922",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-431-8635",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd3b-74af-b2fb-2e0e564abdb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd3b-74af-b2fb-2e0e564abdb3",
        "storage_key": "property/6767906449166880/019d08ab-fd3b-74af-b2fb-2e0e564abdb3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJd2_SvuhzlVQRf4aD6CP2MUg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_e03f98b53f0d21b398433d5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Tualatin Elementary School",
      "poi_type": "Education",
      "poi_address": "20405 SW 95th Ave, Tualatin, OR 97062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://tualatin.ttsdschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10602802015814454478&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tualatin-elementary-school",
      "poi_latitude": "45.37238840000001",
      "poi_longitude": "-122.776227",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-431-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd51-705b-9772-8f847cf608a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd51-705b-9772-8f847cf608a0",
        "storage_key": "property/6767906449166880/019d08ab-fd51-705b-9772-8f847cf608a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJwa46KH9tlVQRzoxq4EG4JJM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_0bb582f1d7eb5456a8a34b0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Bridgeport Elementary School",
      "poi_type": "Education",
      "poi_address": "5505 SW Borland Rd, Tualatin, OR 97062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-7a2a-7337-a0b2-8a4f3012bf67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-7a2a-7337-a0b2-8a4f3012bf67",
        "storage_key": "property/6767906449166880/019d08ab-7a2a-7337-a0b2-8a4f3012bf67.webp",
        "width": 1280,
        "height": 604
      },
      "poi_business_url": "https://bridgeport.ttsdschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13482999788525004131&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bridgeport-elementary-school",
      "poi_latitude": "45.3783398",
      "poi_longitude": "-122.732584",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 503-431-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd51-705b-9772-8f847cf608a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd51-705b-9772-8f847cf608a0",
        "storage_key": "property/6767906449166880/019d08ab-fd51-705b-9772-8f847cf608a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-x4cLVxylVQRYyWzJd88Hbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_fa6503e3047a6b074aecd013",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Hazelbrook Middle School",
      "poi_type": "Education",
      "poi_address": "11300 SW Hazelbrook Rd, Tualatin, OR 97062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-7b07-7643-b144-bee546aec482.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-7b07-7643-b144-bee546aec482",
        "storage_key": "property/6767906449166880/019d08ab-7b07-7643-b144-bee546aec482.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ttsdschools.org/hazelbrook",
      "poi_directions_map_url": "https://maps.google.com/?cid=12620954822128329851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hazelbrook-middle-school",
      "poi_latitude": "45.3928565",
      "poi_longitude": "-122.7924462",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-431-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd51-705b-9772-8f847cf608a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd51-705b-9772-8f847cf608a0",
        "storage_key": "property/6767906449166880/019d08ab-fd51-705b-9772-8f847cf608a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJizOwfadylVQRe2Q2w4qjJq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_82e98e8f12759abde8dde020",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Tualatin High School",
      "poi_type": "Education",
      "poi_address": "22300 SW Boones Ferry Rd, Tualatin, OR 97062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-7c5e-726c-8b3b-f929c54ce088.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-7c5e-726c-8b3b-f929c54ce088",
        "storage_key": "property/6767906449166880/019d08ab-7c5e-726c-8b3b-f929c54ce088.webp",
        "width": 600,
        "height": 412
      },
      "poi_business_url": "https://www.ttsdschools.org/tuhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=2783810351892480424&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tualatin-high-school",
      "poi_latitude": "45.3590205",
      "poi_longitude": "-122.7722557",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 503-431-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd51-705b-9772-8f847cf608a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd51-705b-9772-8f847cf608a0",
        "storage_key": "property/6767906449166880/019d08ab-fd51-705b-9772-8f847cf608a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt7rJVJBtlVQRqEGbCsQUoiY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_4d54c35f5c0dc4da6465f5aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Twality Middle School",
      "poi_type": "Education",
      "poi_address": "14650 SW 97th Ave, Tigard, OR 97224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-81c4-75d9-9bb3-67434c1bce2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-81c4-75d9-9bb3-67434c1bce2c",
        "storage_key": "property/6767906449166880/019d08ab-81c4-75d9-9bb3-67434c1bce2c.webp",
        "width": 1280,
        "height": 942
      },
      "poi_business_url": "http://twality.ttsdschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4603522033317626193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "twality-middle-school",
      "poi_latitude": "45.4142401",
      "poi_longitude": "-122.7751642",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-431-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd51-705b-9772-8f847cf608a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd51-705b-9772-8f847cf608a0",
        "storage_key": "property/6767906449166880/019d08ab-fd51-705b-9772-8f847cf608a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB-v2ZDMNlVQRUcGUF-b-4j8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_f22449419eba53c20315b729",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Horizon Christian Elementary & Middle School",
      "poi_type": "Education",
      "poi_address": "7400 SW Sagert St, Tualatin, OR 97062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-851b-7339-8826-c777cc40b035.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-851b-7339-8826-c777cc40b035",
        "storage_key": "property/6767906449166880/019d08ab-851b-7339-8826-c777cc40b035.webp",
        "width": 968,
        "height": 648
      },
      "poi_business_url": "http://www.horizonchristian.school/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1222301083479759356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "horizon-christian-elementary--middle-school",
      "poi_latitude": "45.374917",
      "poi_longitude": "-122.75328",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 503-692-9312",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd51-705b-9772-8f847cf608a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd51-705b-9772-8f847cf608a0",
        "storage_key": "property/6767906449166880/019d08ab-fd51-705b-9772-8f847cf608a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCW17I31ylVQR_NliAVx89hA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_25ff52b46d1ac22e8494ed8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Horizon Christian High School",
      "poi_type": "Education",
      "poi_address": "23370 SW Boones Ferry Rd, Tualatin, OR 97062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-85f8-74d3-bd3a-7cb9eb4088ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-85f8-74d3-bd3a-7cb9eb4088ab",
        "storage_key": "property/6767906449166880/019d08ab-85f8-74d3-bd3a-7cb9eb4088ab.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://horizonchristian.school/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6845739724448988972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "horizon-christian-high-school",
      "poi_latitude": "45.350822",
      "poi_longitude": "-122.77093",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 503-612-6521",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd51-705b-9772-8f847cf608a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd51-705b-9772-8f847cf608a0",
        "storage_key": "property/6767906449166880/019d08ab-fd51-705b-9772-8f847cf608a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyxTxJZVtlVQRLP-PVAL0AF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_bc55c172a9d8fe399522adbe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Cadence Academy Preschool",
      "poi_type": "Education",
      "poi_address": "6480 SW Nyberg Ln, Tualatin, OR 97062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-8545-70ce-bb25-3d5779567447.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-8545-70ce-bb25-3d5779567447",
        "storage_key": "property/6767906449166880/019d08ab-8545-70ce-bb25-3d5779567447.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.cadence-education.com/locations/or/tualatin/836?utm_source=google&utm_medium=local_listing&utm_campaign=local_seo",
      "poi_directions_map_url": "https://maps.google.com/?cid=2762792437105402266&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cadence-academy-preschool",
      "poi_latitude": "45.3824336",
      "poi_longitude": "-122.7434399",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 503-908-9844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd51-705b-9772-8f847cf608a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd51-705b-9772-8f847cf608a0",
        "storage_key": "property/6767906449166880/019d08ab-fd51-705b-9772-8f847cf608a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmexJ04pylVQRmqHNaRVpVyY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_60c57975238d2a9a15357026",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Tualatin KinderCare",
      "poi_type": "Education",
      "poi_address": "8140 SW Warm Springs St, Tualatin, OR 97062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-8c01-749e-ab3b-b5fafa8a5c2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-8c01-749e-ab3b-b5fafa8a5c2c",
        "storage_key": "property/6767906449166880/019d08ab-8c01-749e-ab3b-b5fafa8a5c2c.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/tualatin/or/300987?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_NTA3NTEyLTcxNS1sb2NhdGlvbi53ZWJzaXRl",
      "poi_directions_map_url": "https://maps.google.com/?cid=12454779491953769189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tualatin-kindercare",
      "poi_latitude": "45.37849869999999",
      "poi_longitude": "-122.7605143",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 503-692-4835",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd51-705b-9772-8f847cf608a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd51-705b-9772-8f847cf608a0",
        "storage_key": "property/6767906449166880/019d08ab-fd51-705b-9772-8f847cf608a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdaKBYIZylVQR5Xq5rfVD2Kw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_4da38ccc2a8dae2a72e2adc3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Clackamas Community College - Wilsonville campus",
      "poi_type": "Education",
      "poi_address": "29353 SW Town Center Loop E, Wilsonville, OR 97070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-9148-72d8-a5d8-c92558704e70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-9148-72d8-a5d8-c92558704e70",
        "storage_key": "property/6767906449166880/019d08ab-9148-72d8-a5d8-c92558704e70.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://www.clackamas.edu/student-life/campuses-buildings-hours/wilsonville-campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=303058160476390447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clackamas-community-college---wilsonville-campus",
      "poi_latitude": "45.3078106",
      "poi_longitude": "-122.7607954",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-594-0940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd51-705b-9772-8f847cf608a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd51-705b-9772-8f847cf608a0",
        "storage_key": "property/6767906449166880/019d08ab-fd51-705b-9772-8f847cf608a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUVPzOPRulVQRL4R6kcqtNAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_0c9d251a09b85730b0e6ddce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Regal Bridgeport Village",
      "poi_type": "Entertainment",
      "poi_address": "7329 SW Bridgeport Rd, Tigard, OR 97224, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-8fe4-7656-8758-e3d2c27c9a78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-8fe4-7656-8758-e3d2c27c9a78",
        "storage_key": "property/6767906449166880/019d08ab-8fe4-7656-8758-e3d2c27c9a78.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-bridgeport-village-0652?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=15369713749186854646&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-bridgeport-village",
      "poi_latitude": "45.3974962",
      "poi_longitude": "-122.7521198",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd94-763e-8631-156e68d8942c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd94-763e-8631-156e68d8942c",
        "storage_key": "property/6767906449166880/019d08ab-fd94-763e-8631-156e68d8942c.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJHwK4wOtylVQR9j64_zgxTNU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_573ede8134fa64e47faeb998",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Bridgeport Village",
      "poi_type": "Entertainment",
      "poi_address": "7455 SW Bridgeport Rd, Tigard, OR 97224, USA",
      "poi_short_description": "Outdoor shopping complex featuring entertainment, high-end retailers & sit-down & casual dining.",
      "poi_long_description": "Outdoor shopping complex featuring entertainment, high-end retailers & sit-down & casual dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-6eed-768d-bb38-82ddac2f078c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-6eed-768d-bb38-82ddac2f078c",
        "storage_key": "property/6767906449166880/019d08ab-6eed-768d-bb38-82ddac2f078c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bridgeport-village.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2515733834919836986&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bridgeport-village",
      "poi_latitude": "45.3957237",
      "poi_longitude": "-122.7528244",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-968-1704",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd3b-74af-b2fb-2e0e564abdb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd3b-74af-b2fb-2e0e564abdb3",
        "storage_key": "property/6767906449166880/019d08ab-fd3b-74af-b2fb-2e0e564abdb3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnYnrbetylVQROv3TC5iu6SI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_7228d6a84c07bfa3f0988140",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "iFLY Indoor Skydiving - Portland",
      "poi_type": "Entertainment",
      "poi_address": "10645 SW Greenburg Rd, Portland, OR 97223, USA",
      "poi_short_description": "Indoor skydiving attraction with wind tunnels for a wide range of ages.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-9126-76ba-a675-0ae9f16a5c08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-9126-76ba-a675-0ae9f16a5c08",
        "storage_key": "property/6767906449166880/019d08ab-9126-76ba-a675-0ae9f16a5c08.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.iflyworld.com/portland/?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3432250689950294985&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ifly-indoor-skydiving---portland",
      "poi_latitude": "45.443465",
      "poi_longitude": "-122.779193",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 971-803-4359",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUwqWyvwMlVQRyaOTUtHNoS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "ec_15e1e79d902d91c7e720d536",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Impact Action Sports",
      "poi_type": "Entertainment",
      "poi_address": "19265 SW Schaber Ln, Tualatin, OR 97062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-9655-7789-adff-212ca9ab82b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-9655-7789-adff-212ca9ab82b8",
        "storage_key": "property/6767906449166880/019d08ab-9655-7789-adff-212ca9ab82b8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.impactactionsports.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6507887827248408870&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "impact-action-sports",
      "poi_latitude": "45.3791197",
      "poi_longitude": "-122.7088135",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-213-3230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgxojgVJylVQRJuk6pX-pUFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "ec_7f0d4ca38c14e55a829e28db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Langer's Entertainment Center",
      "poi_type": "Entertainment",
      "poi_address": "21650 SW Langer Farms Pkwy, Sherwood, OR 97140, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-98e5-742d-b56c-5b25fb0e43eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-98e5-742d-b56c-5b25fb0e43eb",
        "storage_key": "property/6767906449166880/019d08ab-98e5-742d-b56c-5b25fb0e43eb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.langersfun.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18237959855560209962&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "langers-entertainment-center",
      "poi_latitude": "45.3628103",
      "poi_longitude": "-122.835479",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-625-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDZmKDORtlVQRKjaAGtw_Gv0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "ec_104b2ae9eadf161e20846977",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Tualatin Island Greens",
      "poi_type": "Entertainment",
      "poi_address": "20400 SW Cipole Rd, Tualatin, OR 97062, USA",
      "poi_short_description": "Family-friendly spot for pubby American meals at Tualatin Island Greens driving range/putting green.",
      "poi_long_description": "Family-friendly spot for pubby American meals at Tualatin Island Greens driving range/putting green.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-99c0-76a8-8bf1-66e51a892606.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-99c0-76a8-8bf1-66e51a892606",
        "storage_key": "property/6767906449166880/019d08ab-99c0-76a8-8bf1-66e51a892606.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://tualatinislandgreens.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15246435603501926989&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tualatin-island-greens",
      "poi_latitude": "45.3725",
      "poi_longitude": "-122.8077778",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-691-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXUfFDxNtlVQRTcqZ_WY4ltM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "ec_2b69cb536aa96f01cd307747",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Broadway Rose Theatre Company",
      "poi_type": "Entertainment",
      "poi_address": "12850 SW Grant Ave, Tigard, OR 97223, USA",
      "poi_short_description": "Professional musical theatre with year-round mainstage productions & musical theatre classes for all ages.",
      "poi_long_description": "Professional musical theatre with year-round mainstage productions & musical theatre classes for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-99c0-76a8-8bf1-6890a4daa6b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-99c0-76a8-8bf1-6890a4daa6b4",
        "storage_key": "property/6767906449166880/019d08ab-99c0-76a8-8bf1-6890a4daa6b4.webp",
        "width": 1280,
        "height": 450
      },
      "poi_business_url": "https://www.broadwayrose.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11005411535470951552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broadway-rose-theatre-company",
      "poi_latitude": "45.426409",
      "poi_longitude": "-122.7813305",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-620-5262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7Sq6rTwNlVQRgHy7ensTu5g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_e3ca3715dd8ec6f950c6fa98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Bullwinkle's",
      "poi_type": "Entertainment",
      "poi_address": "29111 Town Center Loop W, Wilsonville, OR 97070, USA",
      "poi_short_description": "Family center offering mini-golf, laser tag, bumper boats, go-karting, zip-lining & more.",
      "poi_long_description": "Family center offering mini-golf, laser tag, bumper boats, go-karting, zip-lining & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-9f7d-779c-a0b1-05736ea86f68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-9f7d-779c-a0b1-05736ea86f68",
        "storage_key": "property/6767906449166880/019d08ab-9f7d-779c-a0b1-05736ea86f68.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://bullwinkles.com/wilsonville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6272971267053652515&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bullwinkles",
      "poi_latitude": "45.309665",
      "poi_longitude": "-122.766792",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-685-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSzx_qoxulVQRIwr3uiESDlc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_1aa3133e879125e976e4edf3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "The Circuit Bouldering Gym Tigard",
      "poi_type": "Entertainment",
      "poi_address": "16255 SW Upper Boones Ferry Rd, Tigard, OR 97224, USA",
      "poi_short_description": "Informal gym with rock-climbing walls, bouldering plus a yoga room and kids areas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-a135-713e-9f33-f61867dbf44f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-a135-713e-9f33-f61867dbf44f",
        "storage_key": "property/6767906449166880/019d08ab-a135-713e-9f33-f61867dbf44f.webp",
        "width": 596,
        "height": 335
      },
      "poi_business_url": "http://www.thecircuitgym.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2310958580064154747&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-circuit-bouldering-gym-tigard",
      "poi_latitude": "45.4028854",
      "poi_longitude": "-122.752716",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-596-2332",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAYalUcNylVQRe3Rdp5UsEiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "ec_a20ebfaafc31310051be60bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Legacy Meridian Park Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "19300 SW 65th Ave, Tualatin, OR 97062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-a105-7485-b775-02067d3620f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-a105-7485-b775-02067d3620f1",
        "storage_key": "property/6767906449166880/019d08ab-a105-7485-b775-02067d3620f1.webp",
        "width": 1280,
        "height": 849
      },
      "poi_business_url": "https://www.legacyhealth.org/doctors-and-locations/hospitals/legacy-meridian-park-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=13283930296531003614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legacy-meridian-park-medical-center",
      "poi_latitude": "45.3784235",
      "poi_longitude": "-122.7407424",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 503-692-1212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ac-029e-74ce-a931-554fb45e2cdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-029e-74ce-a931-554fb45e2cdb",
        "storage_key": "property/6767906449166880/019d08ac-029e-74ce-a931-554fb45e2cdb.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJsXGsTWBylVQR3qjHMTkAWrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_a969d5c1e9e08f2bf36b4b06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Providence Immediate Care - Bridgeport",
      "poi_type": "Health and Wellness",
      "poi_address": "18040 SW Lower Boones Ferry Rd Suite 100A, Tigard, OR 97224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-a0fc-7776-9184-b270ccff72c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-a0fc-7776-9184-b270ccff72c4",
        "storage_key": "property/6767906449166880/019d08ab-a0fc-7776-9184-b270ccff72c4.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "https://www.providence.org/locations/urgent-care/or/immediate-care-bridgeport?Is=location&y_source=1_OTU3NjQ1MC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12278276193757270110&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-immediate-care---bridgeport",
      "poi_latitude": "45.3909275",
      "poi_longitude": "-122.7506849",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-216-0724",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ16_4uxylVQRXpAJJyUzZao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_bce59946e48294be78c55bc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Legacy Meridian Park Community Health Education Center",
      "poi_type": "Health and Wellness",
      "poi_address": "19300 SW 65th Ave, Tualatin, OR 97062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.legacyhealth.org/Doctors-and-Locations/hospitals/legacy-meridian-park-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=10957677666944171757&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legacy-meridian-park-community-health-education-center",
      "poi_latitude": "45.3797517",
      "poi_longitude": "-122.7412213",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 503-413-5702",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEWi4E2BylVQR7T5wJch9EZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_2bba1cfafbe254faad4f9165",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Kaiser Permanente Tualatin Medical Office",
      "poi_type": "Health and Wellness",
      "poi_address": "19185 SW 90th Ave, Tualatin, OR 97062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-a808-711b-b749-9afbdf7cc575.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-a808-711b-b749-9afbdf7cc575",
        "storage_key": "property/6767906449166880/019d08ab-a808-711b-b749-9afbdf7cc575.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://healthy.kaiserpermanente.org/oregon-washington/facilities/Tualatin-Medical-Office-100246",
      "poi_directions_map_url": "https://maps.google.com/?cid=13583223607346569008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kaiser-permanente-tualatin-medical-office",
      "poi_latitude": "45.3815118",
      "poi_longitude": "-122.7731965",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 800-813-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3dUl1JxylVQRMJ-XZOdNgbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_a6ce2fb9caaf8eda7d42f985",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Tualatin Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "19297 SW Martinazzi Ave, Tualatin, OR 97062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-a855-700a-8341-8bd0a6f4fbf1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-a855-700a-8341-8bd0a6f4fbf1",
        "storage_key": "property/6767906449166880/019d08ab-a855-700a-8341-8bd0a6f4fbf1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2434182207521362337&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tualatin-pharmacy",
      "poi_latitude": "45.3798901",
      "poi_longitude": "-122.7603666",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 503-218-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsTmND4ZylVQRoRHjJdLzxyE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "ec_9e2f5da082563eb8650844e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7405 SW Nyberg St, Tualatin, OR 97062, USA",
      "poi_short_description": "Chain, clean gym featuring free weights, sports facilities and friendly staff.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-a823-7159-97b9-cdf65392c0bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-a823-7159-97b9-cdf65392c0bb",
        "storage_key": "property/6767906449166880/019d08ab-a823-7159-97b9-cdf65392c0bb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=1097&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=14650673231861924082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "45.385637",
      "poi_longitude": "-122.752729",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-404-0126",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLyqRr41ylVQR8kB0ia6lUcs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_f096b55296c2f5a72030acc0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "19221 SW Martinazzi Ave, Tualatin, OR 97062, USA",
      "poi_short_description": "Gym offering interval training classes that combine cardio and strength training. Friendly coaches, instructors and staff lead the workouts, which feature real-time tracking and heart rate monitors.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-a9d9-7445-8a91-55486f01dd5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-a9d9-7445-8a91-55486f01dd5d",
        "storage_key": "property/6767906449166880/019d08ab-a9d9-7445-8a91-55486f01dd5d.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/tualatin-oregon-0511?utm_medium=seo&utm_source=gg&utm_term=tombras&utm_campaign=reputationdotcom--National",
      "poi_directions_map_url": "https://maps.google.com/?cid=11859239635483285905&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "45.3808975",
      "poi_longitude": "-122.7604287",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-487-0002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1-p97oVylVQRkdk2k517lKQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_1239c99fff5c2b8e279c641b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "CorePower Yoga - Bridgeport Village",
      "poi_type": "Health and Wellness",
      "poi_address": "7497 SW Bridgeport Rd, Tualatin, OR 97224, USA",
      "poi_short_description": "Chain studio offering a range of yoga classes, including hot yoga, in a clean space.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-aeda-704a-add7-f8d24a0db0b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-aeda-704a-add7-f8d24a0db0b8",
        "storage_key": "property/6767906449166880/019d08ab-aeda-704a-add7-f8d24a0db0b8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.corepoweryoga.com/yoga-studios/or/portland/bridgeport-village",
      "poi_directions_map_url": "https://maps.google.com/?cid=11620332859001517382&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corepower-yoga---bridgeport-village",
      "poi_latitude": "45.39395469999999",
      "poi_longitude": "-122.7538883",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 833-448-2561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd51-705b-9772-8f847cf608a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd51-705b-9772-8f847cf608a0",
        "storage_key": "property/6767906449166880/019d08ab-fd51-705b-9772-8f847cf608a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzf0VbOtylVQRRrWVCCu3Q6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_ffd9097599ddf62a57049527",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "17942 SW McEwan Rd, Tigard, OR 97224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-aeb9-7252-9ab1-9742beda2551.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-aeb9-7252-9ab1-9742beda2551",
        "storage_key": "property/6767906449166880/019d08ab-aeb9-7252-9ab1-9742beda2551.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/tigard-or/tualatin-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=709569765366759855&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "45.3942716",
      "poi_longitude": "-122.7437279",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-670-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0jwLe9ylVQRrwELMPHl2Ak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_641745b66a589b66cc104b5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Oregon Occupational Medicine",
      "poi_type": "Health and Wellness",
      "poi_address": "19365 SW 65th Ave #100, Tualatin, OR 97062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-af7a-7188-9364-9e45362d0055.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-af7a-7188-9364-9e45362d0055",
        "storage_key": "property/6767906449166880/019d08ab-af7a-7188-9364-9e45362d0055.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.oregonoccmed.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15198005758644133333&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oregon-occupational-medicine",
      "poi_latitude": "45.37979660000001",
      "poi_longitude": "-122.7445135",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 971-378-2269",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQTHQg4pylVQR1R1TCrcp6tI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "ec_d976b8958b56deaa577beaaf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Tualatin Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8515 SW Tualatin Rd, Tualatin, OR 97062, USA",
      "poi_short_description": "Green space known for its skateboard park, plus a playground, sports fields, dog run & picnic sites.",
      "poi_long_description": "Green space known for its skateboard park, plus a playground, sports fields, dog run & picnic sites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-b061-7645-a9a4-b8545974a7b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-b061-7645-a9a4-b8545974a7b3",
        "storage_key": "property/6767906449166880/019d08ab-b061-7645-a9a4-b8545974a7b3.webp",
        "width": 1280,
        "height": 828
      },
      "poi_business_url": "https://www.tualatinoregon.gov/recreation/tualatin-community-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14735714748933122243&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tualatin-community-park",
      "poi_latitude": "45.385692",
      "poi_longitude": "-122.7635878",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-691-3061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ac-0384-77b6-94d8-99ede063f1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-0384-77b6-94d8-99ede063f1e0",
        "storage_key": "property/6767906449166880/019d08ac-0384-77b6-94d8-99ede063f1e0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJqRiutpZylVQRw6iksX3Gf8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_7fcb508bf83714b563ef0277",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Tualatin Lake at the Commons",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8325 SW Nyberg St, Tualatin, OR 97062, USA",
      "poi_short_description": "Downtown green space with a lake,\ninteractive fountain, restaurants & free summer concert series.",
      "poi_long_description": "Downtown green space with a lake,\ninteractive fountain, restaurants & free summer concert series.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-b561-75e9-898b-40f489af2e98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-b561-75e9-898b-40f489af2e98",
        "storage_key": "property/6767906449166880/019d08ab-b561-75e9-898b-40f489af2e98.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tualatinoregon.gov/recreation/tualatin-lake-commons",
      "poi_directions_map_url": "https://maps.google.com/?cid=10326414323964667104&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tualatin-lake-at-the-commons",
      "poi_latitude": "45.3828614",
      "poi_longitude": "-122.7617618",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-691-3091",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ac-0384-77b6-94d8-99ede063f1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-0384-77b6-94d8-99ede063f1e0",
        "storage_key": "property/6767906449166880/019d08ac-0384-77b6-94d8-99ede063f1e0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJP1LSF49ylVQR4GRrrx3LTo8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_3fd23cfe19c9da2dbe0d5966",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Browns Ferry Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5855 SW Nyberg Ln, Tualatin, OR 97062, USA",
      "poi_short_description": "28-acre riverside park offering kayak & canoe rentals, walking paths & a seasonal art camp for kids.",
      "poi_long_description": "28-acre riverside park offering kayak & canoe rentals, walking paths & a seasonal art camp for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-b7ae-7029-8549-75e149ec2235.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-b7ae-7029-8549-75e149ec2235",
        "storage_key": "property/6767906449166880/019d08ab-b7ae-7029-8549-75e149ec2235.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tualatinoregon.gov/recreation/browns-ferry-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9005979899416023493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "browns-ferry-park",
      "poi_latitude": "45.3834958",
      "poi_longitude": "-122.7382228",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 503-691-3061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ac-0384-77b6-94d8-99ede063f1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-0384-77b6-94d8-99ede063f1e0",
        "storage_key": "property/6767906449166880/019d08ac-0384-77b6-94d8-99ede063f1e0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3b7bvvVylVQRxREAtwCr-3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_830b0fd40c271a1030efb7fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Tualatin River Greenway Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "SW Barngrover Way, Tualatin, OR 97062, USA",
      "poi_short_description": "Riverside pedestrian & biking trail with views of local wildlife & displays on geologic history.",
      "poi_long_description": "Riverside pedestrian & biking trail with views of local wildlife & displays on geologic history.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-b8f6-722a-a080-16d36d30ea5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-b8f6-722a-a080-16d36d30ea5f",
        "storage_key": "property/6767906449166880/019d08ab-b8f6-722a-a080-16d36d30ea5f.webp",
        "width": 1280,
        "height": 801
      },
      "poi_business_url": "https://www.tualatinoregon.gov/recreation/tualatin-river-greenway-trail",
      "poi_directions_map_url": "https://maps.google.com/?cid=12281160218559175443&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tualatin-river-greenway-trail",
      "poi_latitude": "45.3845518",
      "poi_longitude": "-122.7577493",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 503-691-3061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ac-0384-77b6-94d8-99ede063f1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-0384-77b6-94d8-99ede063f1e0",
        "storage_key": "property/6767906449166880/019d08ac-0384-77b6-94d8-99ede063f1e0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJd4DTRo5ylVQRE9vggCZyb6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_867fb740cc8f793f2da0ab6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Canal Acres Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "19300 Canal Rd, Lake Oswego, OR 97035, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-baf5-7391-bd84-0db6e4f57a13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-baf5-7391-bd84-0db6e4f57a13",
        "storage_key": "property/6767906449166880/019d08ab-baf5-7391-bd84-0db6e4f57a13.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ci.oswego.or.us/parksrec/canal-acres-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6714388544347413951&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "canal-acres-nature-park",
      "poi_latitude": "45.3850801",
      "poi_longitude": "-122.7218053",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-697-2549",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ac-0384-77b6-94d8-99ede063f1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-0384-77b6-94d8-99ede063f1e0",
        "storage_key": "property/6767906449166880/019d08ac-0384-77b6-94d8-99ede063f1e0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcaH3SVZylVQRv53Hhc5MLl0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_74c98eef9c6ad761e0b64550",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Bryant Woods Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4301 SW Childs Rd, Lake Oswego, OR 97034, USA",
      "poi_short_description": "Forested park, quiet or hilly place with dirt trails, rocky spots and dog-friendly sections.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-bfa0-708b-b2c9-716f3e781ce0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-bfa0-708b-b2c9-716f3e781ce0",
        "storage_key": "property/6767906449166880/019d08ab-bfa0-708b-b2c9-716f3e781ce0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ci.oswego.or.us/parksrec/bryant-woods-nature-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1016472764081436206&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bryant-woods-nature-park",
      "poi_latitude": "45.3868397",
      "poi_longitude": "-122.7216612",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-675-2549",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ac-0384-77b6-94d8-99ede063f1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-0384-77b6-94d8-99ede063f1e0",
        "storage_key": "property/6767906449166880/019d08ac-0384-77b6-94d8-99ede063f1e0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJufRPGv9ylVQRLvbu6pc8Gw4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_ab48442807915ffd13e14370",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "River Run Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "196980 River Run Dr, Lake Oswego, OR 97034, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-c0c9-7717-9719-55eaccafbf6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-c0c9-7717-9719-55eaccafbf6c",
        "storage_key": "property/6767906449166880/019d08ab-c0c9-7717-9719-55eaccafbf6c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ci.oswego.or.us/parksrec/river-run-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3021483213404382775&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-run-park",
      "poi_latitude": "45.3828761",
      "poi_longitude": "-122.720497",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-675-2549",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ac-0384-77b6-94d8-99ede063f1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-0384-77b6-94d8-99ede063f1e0",
        "storage_key": "property/6767906449166880/019d08ac-0384-77b6-94d8-99ede063f1e0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJA9wVUlFylVQRNybGXfl27ik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_77518d62585a4b80540c9441",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Cook Family Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17005 SW 92nd Ave, Tigard, OR 97224, USA",
      "poi_short_description": "Riverside park offering various sports & picnic areas, as well as a playground & a boat ramp.",
      "poi_long_description": "Riverside park offering various sports & picnic areas, as well as a playground & a boat ramp.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-c1c8-73ac-a2af-427f00e8627b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-c1c8-73ac-a2af-427f00e8627b",
        "storage_key": "property/6767906449166880/019d08ab-c1c8-73ac-a2af-427f00e8627b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tigard-or.gov/Home/Components/FacilityDirectory/FacilityDirectory/143/181",
      "poi_directions_map_url": "https://maps.google.com/?cid=17281400391354763777&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cook-family-park",
      "poi_latitude": "45.39603959999999",
      "poi_longitude": "-122.771663",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-718-2591",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ac-0384-77b6-94d8-99ede063f1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-0384-77b6-94d8-99ede063f1e0",
        "storage_key": "property/6767906449166880/019d08ac-0384-77b6-94d8-99ede063f1e0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJA_XlT7xylVQRAUr_Wxje0-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_d5039c894073f197276a8eae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Mary S. Young Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "19900 Willamette Dr, West Linn, OR 97068, USA",
      "poi_short_description": "128-acre park offering trails, river views, sports fields & a dog park, also known for birding.",
      "poi_long_description": "128-acre park offering trails, river views, sports fields & a dog park, also known for birding.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-c3e8-7768-8a7c-f8890aca1112.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-c3e8-7768-8a7c-f8890aca1112",
        "storage_key": "property/6767906449166880/019d08ab-c3e8-7768-8a7c-f8890aca1112.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://westlinnoregon.gov/parksrec/mary-s-young-park-0",
      "poi_directions_map_url": "https://maps.google.com/?cid=6666791502034247645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mary-s-young-park",
      "poi_latitude": "45.3810341",
      "poi_longitude": "-122.6304188",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-557-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ac-0384-77b6-94d8-99ede063f1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-0384-77b6-94d8-99ede063f1e0",
        "storage_key": "property/6767906449166880/019d08ac-0384-77b6-94d8-99ede063f1e0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkwEGEgd0lVQR3R9YhowzhVw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_153e5b999bcf39ce12bae381",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Tualatin River National Wildlife Refuge Visitor Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "19255 SW Pacific Hwy, Sherwood, OR 97140, USA",
      "poi_short_description": "Suburban nature preserve with walking trails & a visitor's center with educational programming.",
      "poi_long_description": "Suburban nature preserve with walking trails & a visitor's center with educational programming.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-cc08-716c-9485-6e20e54e97e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-cc08-716c-9485-6e20e54e97e9",
        "storage_key": "property/6767906449166880/019d08ab-cc08-716c-9485-6e20e54e97e9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fws.gov/refuge/Tualatin_River/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2731635856280355588&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tualatin-river-national-wildlife-refuge-visitor-center",
      "poi_latitude": "45.3821915",
      "poi_longitude": "-122.8322359",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 503-625-5944",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ac-0384-77b6-94d8-99ede063f1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-0384-77b6-94d8-99ede063f1e0",
        "storage_key": "property/6767906449166880/019d08ac-0384-77b6-94d8-99ede063f1e0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8ZH7EiRtlVQRBINPpVa46CU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_4ce44679d3808bd18703958d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Tualatin WES Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tualatin, OR 97062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-cd64-76fd-b14d-84f1b3a87fe7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-cd64-76fd-b14d-84f1b3a87fe7",
        "storage_key": "property/6767906449166880/019d08ab-cd64-76fd-b14d-84f1b3a87fe7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://trimet.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12252386051580895575&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tualatin-wes-station",
      "poi_latitude": "45.383621",
      "poi_longitude": "-122.764504",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeTHwS4VylVQRVyFurzI4Cao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "ec_4a32761a8035e201edb84bba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Tualatin Park & Ride at Bridgeport Village",
      "poi_type": "Transportation & Transit",
      "poi_address": "SW Travellers Ln, Tigard, OR 97224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://trimet.org/parkandride/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12130404397335039145&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tualatin-park--ride-at-bridgeport-village",
      "poi_latitude": "45.39484359999999",
      "poi_longitude": "-122.7484831",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 888-275-6368",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ac-0384-77b6-94d8-958c2118cfa4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-0384-77b6-94d8-958c2118cfa4",
        "storage_key": "property/6767906449166880/019d08ac-0384-77b6-94d8-958c2118cfa4.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJCVUQT-lylVQRqcz9nIfaV6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_291ed1ca8b023668e92d7c62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Mohawk Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Southwest Martinazzi Avenue &, SW Mohawk St, Tualatin, OR 97062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-ce1c-72f8-9a55-1c6727a9c2df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-ce1c-72f8-9a55-1c6727a9c2df",
        "storage_key": "property/6767906449166880/019d08ab-ce1c-72f8-9a55-1c6727a9c2df.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://trimet.org/parkandride/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097260802288721534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mohawk-park--ride",
      "poi_latitude": "45.3760573",
      "poi_longitude": "-122.7598596",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ac-0384-77b6-94d8-958c2118cfa4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-0384-77b6-94d8-958c2118cfa4",
        "storage_key": "property/6767906449166880/019d08ac-0384-77b6-94d8-958c2118cfa4.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJM0BK3txzlVQRfh5VH2XSnVQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_af1581223be3804cc2883ce9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Tigard Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "11632 SW Pacific Hwy, Tigard, OR 97223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://trimet.org/parkandride/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4314056433795825996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tigard-park--ride",
      "poi_latitude": "45.4378065",
      "poi_longitude": "-122.7530695",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ac-0384-77b6-94d8-958c2118cfa4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-0384-77b6-94d8-958c2118cfa4",
        "storage_key": "property/6767906449166880/019d08ac-0384-77b6-94d8-958c2118cfa4.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3enLTLsNlVQRTIFjPXib3js",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_ffb3f3ee807d5152ea95a2da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Tigard Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "8960 SW Commercial St, Portland, OR 97223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-cd0a-759c-986f-5b52e2f3cba1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-cd0a-759c-986f-5b52e2f3cba1",
        "storage_key": "property/6767906449166880/019d08ab-cd0a-759c-986f-5b52e2f3cba1.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://trimet.org/transitcenters/index.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=5537393027262128833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tigard-transit-center",
      "poi_latitude": "45.4302634",
      "poi_longitude": "-122.7693506",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-238-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ac-03af-725d-b7e1-72e4708674e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-03af-725d-b7e1-72e4708674e0",
        "storage_key": "property/6767906449166880/019d08ac-03af-725d-b7e1-72e4708674e0.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJaWpvpSANlVQRwSKvs57F2Ew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_dba599a08b124db2ffe6fe70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Washington Square Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tigard, OR 97223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-d47a-73fc-a490-d05bdf438500.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-d47a-73fc-a490-d05bdf438500",
        "storage_key": "property/6767906449166880/019d08ab-d47a-73fc-a490-d05bdf438500.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3751353937186555184&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-square-transit-center",
      "poi_latitude": "45.4527",
      "poi_longitude": "-122.77881",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZeBK_vcMlVQRMIXExId8DzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_63e933408d09457cfb1f105a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Wilsonville Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "9699 SW Barber St, Wilsonville, OR 97070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-d5fb-74bb-b8a8-c4d57be25121.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-d5fb-74bb-b8a8-c4d57be25121",
        "storage_key": "property/6767906449166880/019d08ab-d5fb-74bb-b8a8-c4d57be25121.webp",
        "width": 288,
        "height": 288
      },
      "poi_business_url": "https://www.ridesmart.com/transit/page/wilsonville-transit-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=8292288715551228446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wilsonville-transit-center",
      "poi_latitude": "45.3108285",
      "poi_longitude": "-122.7753601",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-682-7790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ac-0384-77b6-94d8-958c2118cfa4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-0384-77b6-94d8-958c2118cfa4",
        "storage_key": "property/6767906449166880/019d08ac-0384-77b6-94d8-958c2118cfa4.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJWSt7YJVvlVQRHkJpAacgFHM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking"
    },
    {
      "id": "ec_eed572c621892ab46e2831d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Beaverton Transit center",
      "poi_type": "Transportation & Transit",
      "poi_address": "4050 SW Lombard Ave, Beaverton, OR 97005, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-d67c-736f-b0ec-a3ae2be779b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-d67c-736f-b0ec-a3ae2be779b3",
        "storage_key": "property/6767906449166880/019d08ab-d67c-736f-b0ec-a3ae2be779b3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4565063240923663999&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaverton-transit-center",
      "poi_latitude": "45.49109660000001",
      "poi_longitude": "-122.8011257",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "4 hours 1 min",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5wBVLnUPlVQRf85ytNRcWj8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "ec_eb36fdc6a92b027f3e7e0669",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Sunny Day Spa",
      "poi_type": "Transportation & Transit",
      "poi_address": "19300 SW Boones Ferry Rd #5, Tualatin, OR 97062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-d64b-7538-b692-2380139a6a25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-d64b-7538-b692-2380139a6a25",
        "storage_key": "property/6767906449166880/019d08ab-d64b-7538-b692-2380139a6a25.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3722368926005265296&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunny-day-spa",
      "poi_latitude": "45.38031660000001",
      "poi_longitude": "-122.7637024",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 971-406-8251",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7X2cblpzlVQRkAN_9dCCqDM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "spa"
    },
    {
      "id": "ec_3df682655291889b93f0bc2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Portland International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "7000 NE Airport Way, Portland, OR 97218, USA",
      "poi_short_description": "Hub featuring direct rail service to Downtown, plus works by regional artists & frequent live music.",
      "poi_long_description": "Hub featuring direct rail service to Downtown, plus works by regional artists & frequent live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-dd4d-7306-bbda-6ec7f884a707.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-dd4d-7306-bbda-6ec7f884a707",
        "storage_key": "property/6767906449166880/019d08ab-dd4d-7306-bbda-6ec7f884a707.webp",
        "width": 1000,
        "height": 668
      },
      "poi_business_url": "https://www.flypdx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6618732977047100477&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "portland-international-airport",
      "poi_latitude": "45.5852698",
      "poi_longitude": "-122.5917184",
      "poi_miles_from_property": "21.4 mi",
      "poi_walking_minutes": "7 hours 54 mins",
      "poi_biking_minutes": "2 hours 23 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 503-460-4234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ac-09dc-7082-92e7-3c4c84887ddf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-09dc-7082-92e7-3c4c84887ddf",
        "storage_key": "property/6767906449166880/019d08ac-09dc-7082-92e7-3c4c84887ddf.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0SDcdKqglVQRPVwOOJN22ls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_f96707050a4b73fdc66ff5c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Legacy Meridian Park Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "19300 SW 65th Ave, Tualatin, OR 97062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-a105-7485-b775-02067d3620f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-a105-7485-b775-02067d3620f1",
        "storage_key": "property/6767906449166880/019d08ab-a105-7485-b775-02067d3620f1.webp",
        "width": 1280,
        "height": 849
      },
      "poi_business_url": "https://www.legacyhealth.org/doctors-and-locations/hospitals/legacy-meridian-park-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=13283930296531003614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legacy-meridian-park-medical-center",
      "poi_latitude": "45.3784235",
      "poi_longitude": "-122.7407424",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 503-692-1212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ac-029e-74ce-a931-554fb45e2cdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-029e-74ce-a931-554fb45e2cdb",
        "storage_key": "property/6767906449166880/019d08ac-029e-74ce-a931-554fb45e2cdb.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJsXGsTWBylVQR3qjHMTkAWrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_716e33117d79ba9fc2018e19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Teledyne FLIR",
      "poi_type": "Major Employers & Offices",
      "poi_address": "27700 SW Parkway Ave, Wilsonville, OR 97070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-de9b-72b8-ad78-2e0f145e2783.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-de9b-72b8-ad78-2e0f145e2783",
        "storage_key": "property/6767906449166880/019d08ab-de9b-72b8-ad78-2e0f145e2783.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://flir.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14732829060148464021&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "teledyne-flir",
      "poi_latitude": "45.3197693",
      "poi_longitude": "-122.7646369",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-498-3547",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0zz1NmNulVQRlYmz6viFdcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_629d7a82c59392bd01a3d71a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Siemens EDA",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8005 Boeckman Rd, Wilsonville, OR 97070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-df1e-744f-8b45-1fe400622e1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-df1e-744f-8b45-1fe400622e1e",
        "storage_key": "property/6767906449166880/019d08ab-df1e-744f-8b45-1fe400622e1e.webp",
        "width": 650,
        "height": 366
      },
      "poi_business_url": "http://www.mentor.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16340016877974898437&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "siemens-eda",
      "poi_latitude": "45.3187316",
      "poi_longitude": "-122.7627068",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-547-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgYB9imNulVQRBceUA8dmw-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_0debda1dcb01ad759db09529",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Xerox",
      "poi_type": "Major Employers & Offices",
      "poi_address": "27063 SW Canyon Creek Rd, Wilsonville, OR 97070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-df41-74b9-b6f7-eb8d0068fa78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-df41-74b9-b6f7-eb8d0068fa78",
        "storage_key": "property/6767906449166880/019d08ab-df41-74b9-b6f7-eb8d0068fa78.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.xerox.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14059644808667529272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "xerox",
      "poi_latitude": "45.3222539",
      "poi_longitude": "-122.7597632",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 855-618-6485",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHbqdkfRulVQROADLWHbkHcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_cda9e79781f1e0c18c8767e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Collins Aerospace",
      "poi_type": "Major Employers & Offices",
      "poi_address": "27300 SW Parkway Ave building 594, Wilsonville, OR 97070, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-e76e-7248-a58a-be36407d30fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-e76e-7248-a58a-be36407d30fe",
        "storage_key": "property/6767906449166880/019d08ab-e76e-7248-a58a-be36407d30fe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.collinsaerospace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10658633794014943630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "collins-aerospace",
      "poi_latitude": "45.3223861",
      "poi_longitude": "-122.7649726",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-404-6888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy45Ku9ZtlVQRjhk8u_YS65M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_a092dff6f1dafdf9b463ed28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Columbia Distributing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "27200 SW Parkway Ave, Wilsonville, OR 97070, USA",
      "poi_short_description": "Beverage distributor carrying a selection of alcoholic and nonalcoholic brands.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-e847-74d8-a255-818a593274a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-e847-74d8-a255-818a593274a8",
        "storage_key": "property/6767906449166880/019d08ab-e847-74d8-a255-818a593274a8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.coldist.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4724129141668828558&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "columbia-distributing",
      "poi_latitude": "45.322983",
      "poi_longitude": "-122.7666311",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-274-9990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs7QQgpqnlVQRjtU9wmx6j0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_be74a39a77d8679ab9534ba7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Swire Coca-Cola, USA Production Plant",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9750 SW Barber St, Wilsonville, OR 97070, USA",
      "poi_short_description": "Chain facility that produces, sells, and distributes Coca-Cola and other beverages.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-e9a5-712a-9804-3fee4dfdd9b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-e9a5-712a-9804-3fee4dfdd9b3",
        "storage_key": "property/6767906449166880/019d08ab-e9a5-712a-9804-3fee4dfdd9b3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://swirecc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10103886552127851700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "swire-coca-cola-usa-production-plant",
      "poi_latitude": "45.3093752",
      "poi_longitude": "-122.77817",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-682-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH5MviY1ulVQRtExtVkk3OIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_56c8b1097a515b0970b8f84a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "Tigard-Tualatin School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6960 SW Sandburg St, Tigard, OR 97223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ttsdschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11945723187973209141&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tigard-tualatin-school-district",
      "poi_latitude": "45.4203786",
      "poi_longitude": "-122.7494692",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-431-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd51-705b-9772-8f847cf608a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd51-705b-9772-8f847cf608a0",
        "storage_key": "property/6767906449166880/019d08ab-fd51-705b-9772-8f847cf608a0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf7o8UyMNlVQRNTxKxPK7x6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_ebad6c231402d1c3e8685e37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "poi_name": "18880 SW Martinazzi Ave",
      "poi_type": "Major Employers & Offices",
      "poi_address": "18880 SW Martinazzi Ave, Tualatin, OR 97062, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4393918943232315038&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "18880-sw-martinazzi-ave",
      "poi_latitude": "45.3843097",
      "poi_longitude": "-122.7583852",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd32-73f9-9939-2c2cc6738907",
        "storage_key": "property/6767906449166880/019d08ab-fd32-73f9-9939-2c2cc6738907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2adFSY5ylVQRns44t_9V-jw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "premise"
    }
  ],
  "office_hours": [
    {
      "id": "ec_98eeaa5a2497f6200cefbfd7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_829023ddafaca5f4198d601b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_d283c01c05a7bf83173b2da5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_e2652a37dc67c79cf3359e7f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_b6f40eed6975ba908387e7c4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_752d05e2cc6c5667f3a8baa8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "day": "SAT",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_5eeee75a8b4d500bf3795ec0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "day": "SUN",
      "open_time": "10:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "ec_844ad1b37c7c287693233a86",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "rating": "4",
      "name": "false",
      "text": "First apartment and there was a Flee infestation the first month, but everything else was great.",
      "date": "false",
      "title": "Great start"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_012efda3164a5626314e1c19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ad-7a2a-74dd-bffa-7a644e978378.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "View of kitchen and living room with sliding glass doors leading outside",
        "public_id": "019d08ad-7a2a-74dd-bffa-7a644e978378",
        "storage_key": "property/6767906449166880/019d08ad-7a2a-74dd-bffa-7a644e978378.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 646SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=3PMUzoaJqCo"
    },
    {
      "id": "ec_d6e1e72ebd06c2bb47b104e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ad-7a2d-70a9-a119-0c5f52c4ebd0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with carpet and sliding glass doors leading to a balcony.",
        "public_id": "019d08ad-7a2d-70a9-a119-0c5f52c4ebd0",
        "storage_key": "property/6767906449166880/019d08ad-7a2d-70a9-a119-0c5f52c4ebd0.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 1BA - 750SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Ku7kLA3BtLK"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a9def-d2b2-739e-968b-07cd81e2e37c",
      "lead_source": "LANDING_PAGE",
      "name": "Rolling Hills landing page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "apartments-scenic-views-tualatin-or",
      "search_query": "apartments with scenic views in Tualatin OR",
      "category": "Amenity",
      "h1_title": "Apartments with Scenic Views in Tualatin",
      "h2_subtitle": "Discover the beauty of Tualatin from our apartments with scenic views. Rolling Hills offers stunning landscapes and a comfortable living experience.",
      "page_copy": "Welcome to Rolling Hills, where the allure of Tualatin's breathtaking landscapes is right outside your window. Our apartments are designed to enhance your living experience with stunning scenic views that capture the essence of Oregon’s natural beauty. From studio to spacious three-bedroom layouts, Rolling Hills provides the perfect setting to relax and soak in these picturesque sights every day.\n\nNestled in the serene Sherwood - Tualatin South neighborhood, our community offers more than just incredible views. Enjoy our cozy coffee bar, ample closet storage, and self-service package lockers. Whether you're gazing out at the greenery or enjoying our resident activity program, Rolling Hills is where comfort meets the beauty of nature. Experience Tualatin's finest living—contact us today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Scenic Views in Tualatin",
      "seo_description": "Explore Rolling Hills for Tualatin apartments with scenic views. Enjoy comfort, convenience, and captivating landscapes. Book a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "smoke-free-apartments-washington-county",
      "search_query": "smoke free apartments in Washington County",
      "category": "Amenity",
      "h1_title": "Smoke-Free Apartments in Washington County",
      "h2_subtitle": "Enjoy clean living in our smoke-free apartments at Rolling Hills, Washington County. Experience fresh air and a peaceful environment.",
      "page_copy": "Nestled in the heart of Tualatin in Washington County, Rolling Hills offers a smoke-free living environment that promotes health and tranquility. Say goodbye to smoke-filled air and hello to fresh surroundings as you settle into one of our thoughtfully designed apartments. From studios to three-bedroom floor plans, our community provides a variety of options to suit your lifestyle.\n\nRolling Hills not only offers a smoke-free environment but also a host of amenities to enhance daily living. Residents can enjoy our scenic views, ample closet storage, and engage in our resident activity program. Whether you're making a coffee from our cozy bar or utilizing our convenient self-service package lockers, our community is designed for comfortable and clean living in Washington County's vibrant setting.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke-Free Apartments in Washington County",
      "seo_description": "Rolling Hills offers smoke-free apartments in Washington County. Enjoy a healthy lifestyle with great amenities in a clean air environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "self-service-package-lockers-sherwood-tualatin-south",
      "search_query": "self-service package lockers in Sherwood - Tualatin South",
      "category": "Amenity",
      "h1_title": "Self-Service Package Lockers on Offer",
      "h2_subtitle": "Rolling Hills in Sherwood - Tualatin South provides convenient self-service package lockers. Enjoy hassle-free parcel pickup.",
      "page_copy": "At Rolling Hills in the Sherwood - Tualatin South neighborhood, convenience is key. Our self-service package lockers are the perfect solution for managing your deliveries with ease. Say goodbye to missed package deliveries and enjoy the flexibility of picking up parcels on your schedule. This amenity makes online shopping stress-free and ensures that your packages are secure until you're ready to collect them.\n\nLocated in serene Tualatin, Rolling Hills offers more than just convenient parcel solutions. Our community features inviting amenities, from spacious floor plans with ample closet storage to a cozy coffee bar. The scenic views surrounding our smoke-free apartments enhance your living experience. Make Rolling Hills your home and enjoy modern conveniences in a tranquil setting.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Self-Service Package Lockers Available",
      "seo_description": "Discover Rolling Hills' self-service package lockers in Sherwood - Tualatin South. Secure and convenient, ideal for managing all your deliveries.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "apartments-stackable-washer-dryer-tualatin",
      "search_query": "apartments with stackable washer & dryer Tualatin",
      "category": "Amenity",
      "h1_title": "Apartments with Washer & Dryer in Tualatin",
      "h2_subtitle": "Enjoy the convenience of stackable washer & dryer units in Tualatin at Rolling Hills. Easy laundry days in a comfortable community.",
      "page_copy": "Discover the ease of living at Rolling Hills in Tualatin, where every apartment is equipped with stackable washer & dryer units. These in-unit conveniences make laundry days a breeze, leaving you with more time to enjoy our community amenities and the vibrant local area. From studios to three-bedroom selections, each floor plan is designed to offer comfort and practicality.\n\nLocated in the charming Sherwood - Tualatin South neighborhood, Rolling Hills also boasts an array of amenities such as ample closet storage and a resident activity program. Enjoy a fresh cup from our coffee bar or use one of our self-service package lockers for seamless parcel handling. With stunning scenic views and a smoke-free environment, Rolling Hills is the ideal place to call home in Tualatin.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Washer & Dryer in Tualatin",
      "seo_description": "Find Tualatin apartments at Rolling Hills with stackable washer & dryer units, perfect for convenient living. Contact us to schedule a tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "coffee-bar-apartments-near-97062",
      "search_query": "coffee bar apartments near 97062",
      "category": "Amenity",
      "h1_title": "Coffee Bar Apartments Near 97062",
      "h2_subtitle": "Experience community and comfort at Rolling Hills near 97062, featuring a cozy coffee bar just steps from your apartment.",
      "page_copy": "Located near the 97062 area, Rolling Hills Apartments provide the perfect blend of convenience and community with the addition of our inviting coffee bar. Start your mornings or unwind after a long day with a freshly brewed cup, enjoying the serene ambiance that our Tualatin location offers. Our coffee bar is not only a place to grab a drink but also a community gathering spot where residents can connect and relax.\n\nBeyond the coffee bar, Rolling Hills offers a range of amenities designed to enhance your lifestyle. Choose from spacious studio to three-bedroom floor plans with ample closet storage and modern conveniences like self-service package lockers. Situated in the heart of Sherwood - Tualatin South, our smoke-free community provides scenic views and a resident activity program, ensuring a fulfilling living experience near the 97062 ZIP code.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Coffee Bar Apartments Near 97062",
      "seo_description": "Rolling Hills offers apartments near 97062 with a cozy coffee bar and modern amenities. Ideal for those seeking comfort and community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "studio-apartments-tualatin-or",
      "search_query": "studio apartments in Tualatin OR",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Tualatin, OR",
      "h2_subtitle": "Find your ideal studio apartment at Rolling Hills in Tualatin, OR. Discover comfort and convenience in a prime location.",
      "page_copy": "Explore the perfect blend of comfort and convenience with studio apartments at Rolling Hills in Tualatin, OR. Designed to make the most of their cozy spaces, these studios offer ample closet storage and chic, efficient layouts that cater to all lifestyle needs. Enjoy the benefits of living in a vibrant community with access to amenities that include a resident activity program and self-service package lockers, all thoughtfully designed to enhance your experience.\n\nNestled in the scenic Sherwood - Tualatin South area, our community at Rolling Hills provides not just a place to live, but a place to thrive. Grab a cup at our coffee bar or take in the tranquility of the surrounding views. Whether you're starting fresh or downsizing, our studio apartments offer a welcoming atmosphere in a smoke-free environment. Discover your new home at Rolling Hills today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Tualatin, OR",
      "seo_description": "Discover studio apartments in Tualatin, OR at Rolling Hills. Comfort and convenience merge in this vibrant, amenity-rich community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-sherwood-tualatin",
      "search_query": "1 bedroom apartments Sherwood Tualatin",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Sherwood-Tualatin",
      "h2_subtitle": "Discover spacious 1 bedroom apartments in the Sherwood-Tualatin area at Rolling Hills. Enjoy modern living with exceptional amenities.",
      "page_copy": "Welcome to Rolling Hills, where you can find charming 1 bedroom apartments in the desirable Sherwood-Tualatin area. Our thoughtfully designed floor plans maximize comfort and functionality, providing you with ample closet storage and stylish finishes. Whether you're relaxing after a long day or entertaining guests, these apartments offer the perfect setting for all your lifestyle needs.\n\nLocated in a picturesque neighborhood, Rolling Hills is more than just a place to live; it's a thriving community. Join fellow residents at our cozy coffee bar or participate in our engaging activity program. With conveniences like self-service package lockers and online service requests, everything is tailored to make life easier. Discover the perfect balance of luxury and convenience in the heart of Sherwood-Tualatin.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Sherwood-Tualatin",
      "seo_description": "Find 1 bedroom apartments in Sherwood-Tualatin at Rolling Hills. Enjoy modern living and community amenities. Explore our offerings today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-washington-county",
      "search_query": "2 bedroom apartments Washington County",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Washington County",
      "h2_subtitle": "Explore our spacious 2 bedroom apartments in Washington County at Rolling Hills, offering comfort and modern amenities.",
      "page_copy": "Discover the spacious and inviting 2 bedroom apartments available at Rolling Hills, ideally situated in Washington County. These well-designed residences offer both style and functionality, with expansive living areas and ample closet storage to meet all your needs. Each apartment serves as a comfortable retreat, perfect for individuals and families alike.\n\nLiving at Rolling Hills means enjoying a vibrant community set amid scenic surroundings. Engage with neighbors at our charming coffee bar or partake in various activities through our resident program. From self-service package lockers to online service requests, convenience is at the forefront of our offerings. Make the most of your home in Washington County by choosing our beautifully appointed 2 bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Washington County",
      "seo_description": "Rolling Hills offers 2 bedroom apartments in Washington County. Spacious living with modern amenities in a vibrant community. Learn more today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-near-97062",
      "search_query": "3 bedroom apartments near 97062",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Near 97062",
      "h2_subtitle": "Explore the spacious 3 bedroom apartments near 97062 at Rolling Hills, perfectly combining comfort and convenience.",
      "page_copy": "Experience the pinnacle of spacious living with our 3 bedroom apartments near the 97062 area at Rolling Hills. Perfect for families or those needing extra space, these residences are designed to provide both comfort and practicality. Each apartment boasts ample storage solutions and a well-thought-out floor plan that enhances your daily living experience.\n\nLocated strategically in the serene surroundings of Tualatin, Rolling Hills offers more than just a home. Enjoy community amenities such as a cozy coffee bar, a resident activity program, and efficient self-service package lockers. Our community is crafted to deliver an enriching lifestyle, all within a welcoming environment that ensures you feel right at home. Discover the ideal combination of style and convenience today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near 97062",
      "seo_description": "Find spacious 3 bedroom apartments near 97062 at Rolling Hills. Enjoy a blend of comfort and community amenities. Discover more about our offerings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "apartments-near-tualatin-elementary-school",
      "search_query": "apartments near Tualatin Elementary School",
      "category": "School",
      "h1_title": "Apartments Near Tualatin Elementary School",
      "h2_subtitle": "Explore convenience and comfort at Rolling Hills, where apartments are perfectly located near Tualatin Elementary School.",
      "page_copy": "Rolling Hills presents the ideal living solution with apartments conveniently located near Tualatin Elementary School. Our community offers a range of thoughtfully designed studio to three-bedroom floor plans, making it perfect for families seeking both comfort and proximity to quality education.\n\nNestled in the heart of Tualatin, our community offers a host of amenities, including a resident activity program and a cozy coffee bar, fostering a friendly atmosphere. With features such as ample closet storage and easy access to online service requests, Rolling Hills is crafted to support both family life and convenient living. Make the smart choice by choosing apartments that cater to both your living needs and educational aspirations.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tualatin Elementary School",
      "seo_description": "Discover apartments near Tualatin Elementary School at Rolling Hills. Perfect for families seeking comfort and convenience. Learn more today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "rolling-hills-apartments-near-bridgeport-elementary",
      "search_query": "rolling hills apartments close to Bridgeport Elementary School",
      "category": "School",
      "h1_title": "Rolling Hills Apartments Near Bridgeport Elem.",
      "h2_subtitle": "Discover Rolling Hills apartments, ideally located close to Bridgeport Elementary School, offering convenience and community living.",
      "page_copy": "At Rolling Hills, experience a blend of convenience and community living with our apartments strategically located close to Bridgeport Elementary School. Our thoughtfully crafted studio to three-bedroom floor plans ensure ample living space for families desiring proximity to educational facilities.\n\nEmbrace the vibrant lifestyle at Rolling Hills, where community-centric amenities like a resident activity program and a cozy coffee bar await. With self-service package lockers and online service requests, we ensure everyday living is seamless and worry-free. Nestled in a welcoming environment, Rolling Hills positions you perfectly for easy access to both city life and quality education, making it an ideal home base.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rolling Hills Apts Near Bridgeport Elementary",
      "seo_description": "Rolling Hills offers apartments close to Bridgeport Elementary. Enjoy convenience with spacious living and community amenities. Discover more today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "apartments-near-hazelbrook-middle-school-wc",
      "search_query": "apartments near Hazelbrook Middle School in Washington County",
      "category": "School",
      "h1_title": "Apartments Near Hazelbrook Middle School",
      "h2_subtitle": "Find the perfect apartment near Hazelbrook Middle School in Washington County at Rolling Hills, offering comfort and community.",
      "page_copy": "Discover the ideal living space at Rolling Hills, where apartments are conveniently located near Hazelbrook Middle School in Washington County. Designed with families in mind, our studio to three-bedroom floor plans cater to those seeking proximity to quality education and community amenities.\n\nRolling Hills is not just a place to live; it's a community offering resident-focused features such as a welcoming coffee bar and a dynamic resident activity program. Our ample closet storage and self-service package lockers complement the convenience of online service requests, making life at Rolling Hills both comfortable and practical. Enjoy the best of both worlds with a home that supports your educational and lifestyle needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Hazelbrook Middle School in Washington County",
      "seo_description": "Explore apartments near Hazelbrook Middle School at Rolling Hills. Located in Washington County, offering comfort and convenience. Learn more today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "tualatin-high-school-midwest-or-apartments",
      "search_query": "Tualatin High School midwest OR apartments",
      "category": "School",
      "h1_title": "Tualatin High School Area Apartments",
      "h2_subtitle": "Discover apartments in the Midwest OR area near Tualatin High School. Live comfortably at Rolling Hills with modern amenities and convenience.",
      "page_copy": "Welcome to Rolling Hills, where you can find the perfect apartments situated near Tualatin High School in Midwest OR. Our community offers a variety of studio to three-bedroom layouts, ideal for families seeking convenient access to local schools and community amenities.\n\nEnjoy a pleasant lifestyle with features like a cozy coffee bar, ample closet storage, and an engaging resident activity program. Located in the heart of Tualatin, Rolling Hills provides easy access to the daily necessities and comforts, ensuring a rich living experience. Our self-service package lockers and streamlined online service requests simplify daily routines, making Rolling Hills the ideal choice for school-oriented living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Tualatin High School, Midwest OR",
      "seo_description": "Find Rolling Hills apartments near Tualatin High School in Midwest OR. Experience convenience and modern living. Discover our amenities today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "twality-middle-school-nearby-tualatin-apartments",
      "search_query": "Twality Middle School nearby Tualatin apartments",
      "category": "School",
      "h1_title": "Apartments Near Twality Middle School",
      "h2_subtitle": "Explore Tualatin apartments conveniently located near Twality Middle School. Enjoy comfort and connection at Rolling Hills.",
      "page_copy": "Rolling Hills offers a perfect living option for those seeking Tualatin apartments near Twality Middle School. Our community features a range of studio to three-bedroom floor plans that beautifully blend comfort with proximity to important educational centers.\n\nResidents at Rolling Hills benefit from a vibrant community atmosphere, including engaging amenities like a coffee bar and a resident activity program. With ample storage options and efficient self-service package lockers, living here is as convenient as it is enjoyable. The strategic location in Tualatin ensures that daily commutes are minimal, providing more time for you and your family to relax and enjoy community life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Tualatin Apartments Near Twality Middle School",
      "seo_description": "Find your ideal Tualatin apartment near Twality Middle School at Rolling Hills. Enjoy convenient living with modern amenities. Explore our community today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "apartments-near-horizon-christian-elementary-middle",
      "search_query": "Sherwood - Tualatin South apartments near Horizon Christian Elementary & Middle School",
      "category": "School",
      "h1_title": "Apartments Near Horizon Christian Schools",
      "h2_subtitle": "Discover Sherwood - Tualatin South apartments near Horizon Christian Elementary & Middle School. Enjoy exceptional living at Rolling Hills.",
      "page_copy": "Located in the Sherwood - Tualatin South area, Rolling Hills offers apartments that are perfect for families looking to be near Horizon Christian Elementary & Middle School. Our community features options from studio to three-bedroom layouts, catering to diverse lifestyle needs while ensuring proximity to quality education.\n\nAt Rolling Hills, enjoy modern living with amenities like a convivial coffee bar and an engaging resident activity program that foster community connections. Additional conveniences, such as ample closet storage and self-service package lockers, make everyday life easier, while online service requests simplify maintenance. Choose Rolling Hills for an optimal blend of location, comfort, and community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Horizon Christian Schools in Sherwood-Tualatin",
      "seo_description": "Find Sherwood - Tualatin South apartments near Horizon Christian Elementary & Middle School at Rolling Hills. Enjoy comfortable living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "apartments-close-to-horizon-christian-high-school-tualatin",
      "search_query": "apartments close to Horizon Christian High School Tualatin",
      "category": "School",
      "h1_title": "Apartments Near Horizon Christian High School",
      "h2_subtitle": "Find spacious apartments close to Horizon Christian High School in Tualatin. Experience convenient and modern living at Rolling Hills.",
      "page_copy": "Rolling Hills offers ideal apartment living for those seeking proximity to Horizon Christian High School in Tualatin. Our community provides a selection of studio to three-bedroom apartments, ensuring a perfect fit for various family sizes and preferences.\n\nResidents enjoy a host of amenities that elevate everyday living, such as a welcoming coffee bar and a diverse resident activity program. Benefit from ample closet storage and the ease of self-service package lockers, while our online service requests streamline resident convenience. Make Rolling Hills your new home and live comfortably near one of Tualatin’s reputable educational facilities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Horizon Christian High in Tualatin",
      "seo_description": "Discover Rolling Hills apartments near Horizon Christian High School in Tualatin. Enjoy modern amenities and perfect location. Find your next home today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "apartments-near-clackamas-community-college-wilsonville",
      "search_query": "apartments near Clackamas Community College Wilsonville campus",
      "category": "School",
      "h1_title": "Apartments Near Clackamas Community College",
      "h2_subtitle": "Explore apartments conveniently located near the Clackamas Community College Wilsonville campus. Rolling Hills offers an ideal living experience.",
      "page_copy": "Nestled within the welcoming community of Tualatin, Rolling Hills provides a prime location for students and staff seeking apartments near Clackamas Community College’s Wilsonville campus. Choose from our range of studio to three-bedroom floor plans that cater to diverse living preferences, all while enjoying the peace of mind that comes with a short commute.\n\nRolling Hills offers a vibrant community equipped with modern amenities like a cozy coffee bar and a lively resident activity program. Our residents also have access to practical features like ample closet storage and self-service package lockers, ensuring convenience and ease. Make Rolling Hills the cornerstone of your educational journey and enjoy seamless connectivity to the Wilsonville campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Clackamas Community College Wilsonville",
      "seo_description": "Find ideal living at Rolling Hills near Clackamas Community College Wilsonville campus. Perfectly blend convenience and comfort. Discover our apartments today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "apartments-near-legacy-meridian-park-medical-center",
      "search_query": "apartments near legacy meridian park medical center tualatin",
      "category": "Hospital",
      "h1_title": "Apts Near Legacy Meridian Park Medical Center",
      "h2_subtitle": "Looking for apartments near Legacy Meridian Park Medical Center in Tualatin? Discover the comfort and convenience of Rolling Hills.",
      "page_copy": "Located in the vibrant neighborhood of Tualatin, Rolling Hills offers prime apartments for those wishing to live near Legacy Meridian Park Medical Center. Our community boasts a range of studio to three-bedroom floor plans, ensuring a perfect fit for medical professionals and their families seeking a convenient lifestyle.\n\nRolling Hills combines modern living with exceptional amenities, including a delightful coffee bar and a variety of resident activities to enrich your lifestyle. Enjoy the benefits of ample closet storage and self-service package lockers, along with the convenience of online service requests. Choose Rolling Hills and benefit from an advantageous location close to important medical facilities in Tualatin.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Legacy Meridian Park Medical Center Tualatin",
      "seo_description": "Discover Rolling Hills apartments near Legacy Meridian Park Medical Center in Tualatin. Enjoy comfort, modern amenities, and convenience near healthcare facilities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "apartments-near-tualatin-community-park",
      "search_query": "apartments near Tualatin Community Park",
      "category": "Park",
      "h1_title": "Apts Near Tualatin Community Park",
      "h2_subtitle": "Discover comfortable living with apartments near Tualatin Community Park. Rolling Hills offers a vibrant community and convenient amenities.",
      "page_copy": "For those who cherish the outdoors, Rolling Hills offers the perfect home with its proximity to Tualatin Community Park. Our beautifully designed studio to three-bedroom apartments provide the ideal blend of comfort and accessibility, making it easy for you to enjoy the park's lush green spaces and recreational activities.\n\nRolling Hills enhances your lifestyle with amenities such as a cozy coffee bar, ample closet storage, and a vibrant resident activity program. Take advantage of our self-service package lockers and online service requests, ensuring that convenience is always at your fingertips. Embrace the opportunity to live moments away from Tualatin Community Park, a hub of outdoor fun and community events.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Tualatin Community Park",
      "seo_description": "Experience Rolling Hills apartments near Tualatin Community Park. Enjoy modern amenities, park proximity, and a vibrant community in Tualatin.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "rentals-close-to-tualatin-lake-at-the-commons-or",
      "search_query": "rentals close to Tualatin Lake at the Commons OR",
      "category": "Park",
      "h1_title": "Rentals Close to Tualatin Lake at the Commons",
      "h2_subtitle": "Find rentals close to Tualatin Lake at the Commons, OR. Experience the tranquil environment and modern living at Rolling Hills.",
      "page_copy": "Set in the charming town of Tualatin, Rolling Hills provides an inviting community for those seeking rentals close to Tualatin Lake at the Commons, OR. Offering a selection of floor plans from cozy studios to spacious three-bedroom layouts, our apartments are perfect for anyone looking to enjoy the serene lake views and nearby attractions.\n\nResidents of Rolling Hills can enjoy modern conveniences like a welcoming coffee bar and a range of engaging activities through our resident activity program. With features such as ample closet storage, self-service package lockers, and online service requests, living near Tualatin Lake at the Commons offers unmatched ease and flexibility. Discover the best of Tualatin living at Rolling Hills.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Tualatin Lake at the Commons OR",
      "seo_description": "Discover Rolling Hills rentals close to Tualatin Lake at the Commons, OR. Enjoy tranquility, modern amenities, and lakeside living in Tualatin.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "living-by-browns-ferry-park-tualatin",
      "search_query": "living by Browns Ferry Park Tualatin",
      "category": "Park",
      "h1_title": "Living by Browns Ferry Park in Tualatin",
      "h2_subtitle": "Experience the best of living by Browns Ferry Park, Tualatin. Discover comfortable homes at Rolling Hills, where nature and convenience meet.",
      "page_copy": "Rolling Hills offers a charming blend of nature-inspired living and urban convenience, perfect for those longing to live by Browns Ferry Park in Tualatin. Our community provides a selection of floor plans ranging from studios to three-bedroom apartments, making it easy to find a home that suits your lifestyle.\n\nWith amenities like a cozy coffee bar, spacious closets, and an active resident program, Rolling Hills enhances your living experience. Residents enjoy modern conveniences such as self-service package lockers and online service requests, ensuring everyday tasks are effortless. Make Rolling Hills your new home base, just minutes from the scenic beauty of Browns Ferry Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living by Browns Ferry Park in Tualatin",
      "seo_description": "Secure your spot at Rolling Hills, living by Browns Ferry Park in Tualatin. Enjoy modern living and natural beauty with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "apartments-near-canal-acres-nature-park-97062",
      "search_query": "apartments near Canal Acres Nature Park 97062",
      "category": "Park",
      "h1_title": "Apts Near Canal Acres Nature Park 97062",
      "h2_subtitle": "Discover the joy of living in apartments near Canal Acres Nature Park, 97062. Enjoy the serene setting at Rolling Hills.",
      "page_copy": "Experience living close to nature at Rolling Hills, offering apartments near Canal Acres Nature Park in the 97062 area. Our selection of studio, one, two, and three-bedroom floor plans caters to diverse lifestyle needs, ensuring you have the perfect home adjacent to breathtaking natural landscapes.\n\nAt Rolling Hills, comfort meets convenience with amenities such as a community coffee bar and extensive resident activity programs. Benefit from spacious closet storage and advanced features like self-service package lockers and online service requests, which make everyday life as seamless as possible. Immerse yourself in the peaceful surroundings near Canal Acres Nature Park while residing in Tualatin’s welcoming community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Canal Acres Nature Park 97062",
      "seo_description": "Find comfort and nature at Rolling Hills, offering apartments near Canal Acres Nature Park 97062. Enjoy modern living with serene park proximity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "rentals-near-bryant-woods-nature-park-sherwood",
      "search_query": "rentals near Bryant Woods Nature Park Sherwood",
      "category": "Park",
      "h1_title": "Rentals Near Bryant Woods Nature Park",
      "h2_subtitle": "Explore rentals near Bryant Woods Nature Park, Sherwood. Discover a life of comfort and convenience at Rolling Hills.",
      "page_copy": "Nestled in the heart of Tualatin, Rolling Hills offers idyllic rentals near Bryant Woods Nature Park in Sherwood. Experience a balanced lifestyle with meticulously designed studio, one, two, and three-bedroom options that provide the perfect backdrop for both relaxation and activity.\n\nRolling Hills is equipped with desirable amenities such as a cozy coffee bar and engaging resident activity programs. Enjoy practical features like ample closet storage, self-service package lockers, and online service requests, making daily operations a breeze. With the serene environment of Bryant Woods Nature Park just moments away, experience the best of both convenience and nature at Rolling Hills.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Bryant Woods Nature Park Sherwood",
      "seo_description": "Find ideal rentals at Rolling Hills near Bryant Woods Nature Park, Sherwood. Enjoy modern amenities and a tranquil setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "living-close-to-river-run-park-washington-county",
      "search_query": "living close to River Run Park Washington County",
      "category": "Park",
      "h1_title": "Living Close to River Run Park",
      "h2_subtitle": "Discover the benefits of living close to River Run Park in Washington County. Rolling Hills offers the perfect blend of comfort and nature.",
      "page_copy": "Nestled in Tualatin, Rolling Hills brings you the opportunity of living close to River Run Park in Washington County. Our community offers a range of thoughtfully designed floor plans, from studio to three-bedroom apartments, providing a comfortable and modern living experience.\n\nResidents enjoy amenities designed for convenience, such as a relaxing coffee bar, an engaging resident activity program, and ample closet storage. With self-service package lockers and online service requests, Rolling Hills ensures your living experience is seamless. The proximity to River Run Park affords an ideal setting for nature enthusiasts looking to enjoy all that Washington County offers.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Close to River Run Park",
      "seo_description": "Enjoy living close to River Run Park in Washington County at Rolling Hills. Experience comfort, nature, and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "apartments-near-cook-family-park-or",
      "search_query": "apartments near Cook Family Park OR",
      "category": "Park",
      "h1_title": "Apartments Near Cook Family Park, OR",
      "h2_subtitle": "Find your ideal home at apartments near Cook Family Park, OR. Experience community and comfort at Rolling Hills.",
      "page_copy": "Discover the vibrant living opportunities at Rolling Hills, ideally located near Cook Family Park, OR. Offering an array of floor plans from studios to three-bedroom apartments, our community is designed to cater to diverse lifestyles while ensuring comfort and convenience.\n\nResidents at Rolling Hills benefit from a variety of amenities, including a welcoming coffee bar and a dynamic resident activity program. The spacious closet storage, self-service package lockers, and online service requests further enhance everyday living. Enjoy the beautiful scenery and recreational opportunities at Cook Family Park, located just a short distance from your doorstep at Rolling Hills.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Cook Family Park, OR",
      "seo_description": "Find the perfect apartment at Rolling Hills near Cook Family Park, OR. Enjoy modern amenities and a community-focused lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "rentals-near-mary-s-young-park-tualatin",
      "search_query": "rentals near Mary S. Young Park Tualatin",
      "category": "Park",
      "h1_title": "Rentals Near Mary S. Young Park",
      "h2_subtitle": "Explore rentals near Mary S. Young Park in Tualatin. Rolling Hills offers a tranquil escape with modern comforts.",
      "page_copy": "Rolling Hills presents a unique opportunity to enjoy rentals near Mary S. Young Park, nestled in the charming city of Tualatin. Choose from a selection of well-designed studio to three-bedroom apartments that perfectly balance contemporary amenities with a serene environment.\n\nAt Rolling Hills, residents delight in features such as a cozy coffee bar and an engaging resident activity program. Enhance your living experience with generous closet storage, convenient self-service package lockers, and efficient online service requests. With Mary S. Young Park in proximity, nature lovers can relish the scenic outdoors while living in ultimate comfort at Rolling Hills.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Mary S. Young Park Tualatin",
      "seo_description": "Discover comfortable rentals at Rolling Hills near Mary S. Young Park in Tualatin. Enjoy modern amenities and a peaceful setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "living-by-tualatin-river-wildlife-refuge-97062",
      "search_query": "living by Tualatin River National Wildlife Refuge Visitor Center 97062",
      "category": "Park",
      "h1_title": "Living by Tualatin River Refuge",
      "h2_subtitle": "Enjoy living by Tualatin River National Wildlife Refuge Visitor Center in 97062. Experience nature and modern living at Rolling Hills.",
      "page_copy": "Located in Tualatin, Rolling Hills offers the experience of living by the Tualatin River National Wildlife Refuge Visitor Center, right in the heart of the 97062 area. Our community is perfect for those who appreciate both modern conveniences and the serenity of nature, with floor plans ranging from studio to three-bedroom styles.\n\nResidents benefit from a suite of amenities, including a charming coffee bar, a robust resident activity program, and ample closet storage for all your needs. Our self-service package lockers and online service requests add an extra layer of convenience. With the natural beauty of the Tualatin River National Wildlife Refuge so near, living at Rolling Hills offers a perfect blend of tranquility and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living by Tualatin River Refuge 97062",
      "seo_description": "Experience nature and comfort at Rolling Hills, living by Tualatin River National Wildlife Refuge Visitor Center in 97062.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166880",
      "source": "generator",
      "page_item_url": "apartments-near-portland-international-airport-or",
      "search_query": "apartments near portland international airport or",
      "category": "Transit",
      "h1_title": "Apartments Near Portland International Airport",
      "h2_subtitle": "Find convenient apartments near Portland International Airport, OR at Rolling Hills. Enjoy connectivity and modern living.",
      "page_copy": "Rolling Hills is thrilled to offer apartments near Portland International Airport, OR, providing a unique blend of convenience and comfort. Perfectly suited for frequent travelers and professionals, our community offers a range of living options, from studio to three-bedroom layouts, seamlessly integrating modern amenities.\n\nAt Rolling Hills, experience amenities like a soothing coffee bar and active resident programs designed to enrich your lifestyle. Enjoy the ease of ample closet storage, self-service package lockers, and online service requests. Situated within a short drive from the airport, Rolling Hills presents an ideal living solution without sacrificing the tranquility of a suburban setting.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, apartment buildings in the background.",
        "public_id": "019d08ab-1af9-7601-a863-14049674a735",
        "storage_key": "property/6767906449166880/019d08ab-1af9-7601-a863-14049674a735.webp",
        "width": 2048,
        "height": 1463
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Portland International Airport",
      "seo_description": "Discover Rolling Hills, offering apartments near Portland International Airport, OR. Enjoy modern amenities just a short drive away.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "brianna@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5601"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372402489"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TF9SVX22"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "52024037497"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-805-1228"
    }
  ],
  "custom_csm": "brianna@repli360.com",
  "custom_qb_id": "5601",
  "custom_repli_id": "18372402489",
  "custom_google_gtm_id": "GTM-TF9SVX22",
  "custom_ads_subscription": "essential",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "52024037497",
  "custom_social_subscription": "none",
  "custom_website_subscription": "none",
  "custom_ppc_tracking_phone_number": "844-805-1228"
};

export const generatedAt = '2026-10-20T23:24:14.117Z';
